


// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Button,
//   MenuItem,
//   Typography,
//   Grid,
//   TableContainer,
//   Table,
//   TableHead,
//   TableBody,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Card,
//   CardContent,
//   Autocomplete,
//   Checkbox,
//   FormControlLabel,
//   TextField,
// } from "@mui/material";
// import {
//   Breadcrumb,
//   Cancel,
//   CTSinput,
//   StyledTableCell,
//   StyledTableRow,
// } from "../../reusableComponent/Reusables";
// import { useDispatch } from "react-redux";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useForm } from "react-hook-form";
// import AddIcon from "@mui/icons-material/Add";
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import SaveIcon from "@mui/icons-material/Save";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// import dayjs from "dayjs";
// import deliveryChallanService from "../../../services/deliveryChallan.Service";
// import driverMasterService from "../../../services/masters/driverMaster.Service";
// import depotMasterService from "../../../services/masters/depotMaster.Service";
// import productMasterService from "../../../services/masters/productMaster.Service";
// import vehicleMasterService from "../../../services/masters/vehicleMaster.Service";
// import customerMasterService from "../../../services/masters/customerMaster.Service";
// import supplierMasterService from "../../../services/masters/supplierMaster.Service";
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
// import empty_delivery_challan from "../../../services/empty_delivery_challan";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// // ── Shared styles matching PlantAdd ──────────────────────────────────────────

// const pageSx = {
//   background: "#F4F7FB",
//   minHeight: "100vh",
//   padding: "20px 24px 40px",
//   fontFamily: "'Inter', Arial, sans-serif",
// };

// const breadcrumbSx = {
//   fontSize: "12px",
//   color: "#718096",
//   mb: 2,
//   display: "flex",
//   alignItems: "center",
//   gap: "6px",
// };

// const pageHeaderSx = {
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "space-between",
//   mb: 2.5,
// };

// const pageTitleSx = {
//   fontSize: "16px",
//   fontWeight: 700,
//   color: "#000000",
//   display: "flex",
//   alignItems: "center",
//   gap: "10px",
// };

// const backBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "6px",
//   fontSize: "13px",
//   fontWeight: 600,
//   color: "#2B6CB0",
//   padding: "7px 14px",
//   border: "1.5px solid #2B6CB0",
//   borderRadius: "7px",
//   background: "#fff",
//   cursor: "pointer",
//   textTransform: "none",
//   "&:hover": { background: "#E6F1FB" },
// };

// const formCardSx = {
//   background: "#fff",
//   borderRadius: "14px",
//   border: "1px solid #E2E8F0",
//   overflow: "hidden",
//   mb: 2,
// };

// const sectionHeaderSx = {
//   background: "#1C3A5E",
//   padding: "12px 22px",
//   display: "flex",
//   alignItems: "center",
//   gap: "10px",
// };

// const sectionHeaderTitleSx = {
//   fontSize: "13px",
//   fontWeight: 600,
//   color: "#fff",
//   letterSpacing: "0.3px",
// };

// const formBodySx = { padding: "22px 24px" };

// const fieldLabelSx = {
//   fontSize: "12px",
//   fontWeight: 600,
//   color: "#2063b6",
//   mb: "4px",
//   display: "flex",
//   alignItems: "center",
//   gap: "4px",
// };

// const inputSx = {
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "8px",
//     fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     background: "#fafafa",
//     height: "38px",
//     "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
//     "&:hover fieldset": { borderColor: "#CBD5E0" },
//     "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
//     "&.Mui-focused": { background: "#fff" },
//     "&.Mui-disabled": { background: "#F8FAFC" },
//   },
//   "& input": {
//     color: "#1A202C",
//     fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     "&::placeholder": { color: "#A0AEC0", opacity: 1 },
//   },
//   "& .MuiInputLabel-root": { display: "none" },
// };

// const readonlyInputSx = {
//   ...inputSx,
//   "& .MuiOutlinedInput-root": {
//     ...inputSx["& .MuiOutlinedInput-root"],
//     background: "#F0F4F8",
//   },
// };

// const selectSx = {
//   ...inputSx,
//   "& .MuiOutlinedInput-root": {
//     ...inputSx["& .MuiOutlinedInput-root"],
//     height: "38px",
//   },
// };

// const menuItemSx = { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" };

// const formFooterSx = {
//   padding: "18px 24px",
//   background: "#F8FAFC",
//   borderTop: "1px solid #E2E8F0",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   gap: "10px",
// };

// const saveBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "7px",
//   padding: "0 22px",
//   height: "40px",
//   background: "#4CAF50",
//   color: "#fff",
//   border: "none",
//   fontSize: "14px",
//   fontWeight: 600,
//   textTransform: "none",
//   borderRadius: "8px",
//   fontFamily: "'Inter', Arial, sans-serif",
//   "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
//   "&:active": { transform: "translateY(0)" },
//   "&.Mui-disabled": { background: "#94a3b8", color: "#fff" },
//   transition: "all 0.15s ease",
// };

// const cancelBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "7px",
//   padding: "0 22px",
//   height: "40px",
//   background: "#E53E3E",
//   color: "#ffffff",
//   border: "none",
//   "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
//   fontSize: "14px",
//   fontWeight: 600,
//   borderRadius: "8px",
//   textTransform: "none",
// };

// const inlineInputSx = {
//   "& .MuiInputBase-root": {
//     fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     background: "transparent",
//     "&:before, &:after": { display: "none" },
//   },
//   "& input": { color: "#2D3748", fontSize: "13px", padding: "4px 0" },
// };

// // ─────────────────────────────────────────────────────────────────────────────

// const AddEmptyDeliveryChllan = () => {
//   const dispatch = useDispatch();
//   const login_details = sessionStorage.getItem("loginUser");
//   const userD = JSON.parse(login_details);
//   const userInfo = userD.result.userInfo;
//   const loggedInDepotId = userInfo.depot_id;
//   const { handleSubmit } = useForm();
//   const urlLocation = useLocation();
//   const editInfo = urlLocation.state;
//   const editData = editInfo && editInfo;
//   const [dcType, setDcType] = useState(editData?.to_location || "");
//   const [isLocationSelected, setIsLocationSelected] = useState(!!editData?.to_location);
//   let navigate = useNavigate();
//   const [driver, setDriver] = useState([]);
//   const [depot, setDepot] = useState([]);
//   const [product, setProduct] = useState([]);
//   const [cylinder, setCylinder] = useState([]);
//   const [vehicle, setVehicle] = useState([]);
//   const [customer, setCustomer] = useState([]);
//   const [supplier, setSupplier] = useState([]);
//   const [depot_name, setDepot_name] = useState([]);
//   const depot_id = userInfo.depot_id;
//   const unit_id = userInfo.depot_id || userInfo.plant_id;
//   const short_code = userInfo.depot_short_code || userInfo.plant_short_code;
//   const [checkboxValue, setCheckboxValue] = useState(editData ? editData.update_check || 0 : 0);
//   const [showUnregisteredDriver, setShowUnregisteredDriver] = useState(!!editData?.unregistered_driver);
//   const [showUnregisteredVehicle, setShowUnregisteredVehicle] = useState(!!editData?.unregistered_vehicle);

//   const formatDateForDisplay = (date) => {
//     if (!date) return "";
//     return dayjs(date).isValid() ? dayjs(date).format("DD/MM/YYYY") : "";
//   };

//   const formatDateForAPI = (date) => {
//     if (!date) return "";
//     return dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : "";
//   };

//   const [data, setData] = useState({
//     entry_no: editData ? editData.entry_no : "",
//     entry_date: editData ? formatDateForAPI(editData.entry_date) : formatDateForAPI(new Date()),
//     from_depot: editData ? editData.from_depot : "",
//     to_supplier: editData ? editData.to_supplier : "",
//     to_supplier_id: editData ? editData.to_supplier_id : "",
//     to_customer: editData ? editData.to_customer : "",
//     to_customer_id: editData ? editData.to_customer_id : "",
//     vehicle_no: editData ? editData.vehicle_no : "",
//     vehicle_id: editData ? editData.vehicle_id : "",
//     driver_name: editData ? editData.driver_name : "",
//     driver_id: editData ? editData.driver_id : "",
//     table_details: editData ? editData.table_details : "",
//     to_depot: editData ? editData.to_depot : "",
//     to_depot_id: editData ? editData.to_depot_id : "",
//     fin_year: editData ? editData.fin_year : "",
//     from_depot_id: unit_id,
//     unregistered_driver: editData ? editData.unregistered_driver : "",
//     unregistered_vehicle: editData ? editData.unregistered_vehicle : "",
//     to_location: editData ? editData.to_location : "",
//   });

//   const toggleUnregisteredDriver = () => {
//     setShowUnregisteredDriver((prev) => !prev);
//     if (showUnregisteredDriver) {
//       handleChange({ target: { name: "unregistered_driver", value: "" } });
//     }
//   };

//   const toggleUnregisteredVehicle = () => {
//     setShowUnregisteredVehicle((prev) => !prev);
//     if (showUnregisteredVehicle) {
//       handleChange({ target: { name: "unregistered_vehicle", value: "" } });
//     }
//   };

//   useEffect(() => {
//     async function fetchData() {
//       try {
//         const [driverData, depotData, productData, customerData, vehicleData, cylinderData, delivercylindrData, DdepotData, DcustomerData, supplierData] = await Promise.all([
//           driverMasterService.getDriverList({ page: 0, size: 999, searchKey: "" }),
//           depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
//           productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
//           customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
//           vehicleMasterService.getVehicleList({ page: 0, size: 999, searchKey: "" }),
//           cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
//           empty_delivery_challan.getEmptyDeliveryCylinderList(depot_id),
//           empty_delivery_challan.getEmptyChallandepotList(depot_id),
//           empty_delivery_challan.getEmptyChallanCustomerList(depot_id),
//           supplierMasterService.getSupplierList({ page: 0, size: 999, searchKey: "" }),
//         ]);
//         setDepot(DdepotData);
//         setDriver(driverData);
//         setProduct(productData);
//         setCustomer(DcustomerData);
//         setVehicle(vehicleData);
//         setCylinder(delivercylindrData);
//         setDepot_name(depotData);
//         setSupplier(supplierData);

//         if (editData) {
//           try {
//             const tableDetails = JSON.parse(editData.table_details);
//             const initialCylinders = tableDetails.map((row, index) => ({ sr_no: index + 1, cyl_no: row.cyl_no, prod_code: row.prod_code, status: row.status, tag_no: row.tag_no || "", owner: row.owner || "", remark: row.remark || "" }));
//             setSelectedCylinders(initialCylinders);
//             settable_details(initialCylinders);
//           } catch (error) { console.error("Failed to parse table_details:", error); }
//         }
//       } catch (error) { console.error("Data fetching failed", error); }
//     }
//     fetchData();
//   }, [editData, depot_id]);

//   useEffect(() => {
//     if (editData) {
//       let to_location = editData.to_location || "";
//       if (!to_location) {
//         if (editData.to_depot_id) to_location = "depot";
//         else if (editData.to_supplier_id) to_location = "supplier";
//       }
//       setDcType(to_location);
//       setIsLocationSelected(!!to_location);
//       setData({ entry_no: editData.entry_no || "", entry_date: formatDateForAPI(editData.entry_date), from_depot: editData.from_depot || "", from_depot_id: editData.from_depot_id || "", to_customer: editData.customer_name || "", to_customer_id: editData.to_customer_id || "", to_depot: editData.depot_name || "", to_depot_id: editData.to_depot_id || "", to_supplier: editData.supplier_name || "", to_supplier_id: editData.to_supplier_id || "", to_location: to_location, vehicle_no: editData.vehicle_no || "", vehicle_id: editData.vehicle_id || "", driver_name: editData.driver_name || "", driver_id: editData.driver_id || "", table_details: editData.table_details || [], fin_year: editData.fin_year || "", unit_id: editData.unit_id || "", short_code: editData.short_code || "", unregistered_driver: editData.unregistered_driver || "", unregistered_vehicle: editData.unregistered_vehicle || "" });
//       if (editData.table_details) {
//         let details = editData.table_details;
//         if (typeof details === "string") { try { details = JSON.parse(details); } catch (e) { details = []; } }
//         settable_details(details);
//       }
//     }
//   }, [editData]);

//   const handleTypeChange = (event, newValue) => {
//     const value = newValue ? newValue.toLowerCase() : "";
//     setDcType(value);
//     setIsLocationSelected(!!value);
//     setData((prevData) => ({ ...prevData, to_location: value, type: value, to_customer: "", to_customer_id: "", to_depot: "", to_depot_id: "", to_supplier: "", to_supplier_id: "" }));
//   };

//   const handleChange = ({ target }) => {
//     const { name, value } = target;
//     let updatedFields = { [name]: value };
//     if (name === "entry_date") {
//       updatedFields.entry_date = formatDateForAPI(value);
//       const selectedDate = dayjs(value);
//       if (selectedDate.isValid()) {
//         const month = selectedDate.month(), year = selectedDate.year();
//         updatedFields.fin_year = month >= 3 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
//       }
//     } else if (name === "from_depot_id") {
//       const sel = depot.find(d => d.depot_id === value);
//       if (sel) { updatedFields.from_depot = sel.depot_name; updatedFields.from_depot_id = sel.depot_id; }
//     } else if (name === "to_depot_id") {
//       const sel = depot.find(d => d.depot_id === value);
//       if (sel) { updatedFields.to_depot = sel.depot_name; updatedFields.to_depot_id = sel.depot_id; }
//     } else if (name === "to_customer_id") {
//       const sel = customer.find(c => c.cust_id === value);
//       if (sel) { updatedFields.to_customer = sel.cust_name; updatedFields.to_customer_id = sel.cust_id; }
//     } else if (name === "to_supplier_id") {
//       const sel = supplier.find(s => s.supplier_id === value);
//       if (sel) { updatedFields.to_supplier = sel.supplier_name; updatedFields.to_supplier_id = sel.supplier_id; }
//     } else if (name === "driver_name") {
//       const sel = driver.find(d => d.driver_name === value);
//       updatedFields.driver_id = sel ? sel.driver_id : "";
//       if (value) { updatedFields.unregistered_driver = ""; setShowUnregisteredDriver(false); }
//     } else if (name === "vehicle_no") {
//       const sel = vehicle.find(v => v.vehicle_no === value);
//       updatedFields.vehicle_id = sel ? sel.vehicle_id : "";
//       if (value) { updatedFields.unregistered_vehicle = ""; setShowUnregisteredVehicle(false); }
//     } else if (name === "unregistered_driver" && value) {
//       updatedFields.driver_name = ""; updatedFields.driver_id = "";
//     } else if (name === "unregistered_vehicle" && value) {
//       updatedFields.vehicle_no = ""; updatedFields.vehicle_id = "";
//     }
//     setData(prevData => ({ ...prevData, ...updatedFields }));
//   };

//   const [isUpdateArray, setIsUpdateArray] = useState(false);
//   const [table_details, settable_details] = useState(() => {
//     if (editData) {
//       try {
//         const p = JSON.parse(editData.table_details);
//         return p.map((row, index) => ({ sr_no: index + 1, cyl_no: row.cyl_no || "", prod_code: row.prod_code || "", status: row.status || "Empty", tag_no: row.tag_no || "", owner: row.owner || "", remark: row.remark || "" }));
//       } catch (e) { return [{ sr_no: 1, cyl_no: "", tag_no: "", owner: "", prod_code: "", status: "", remark: "" }]; }
//     }
//     return [{ sr_no: 1, cyl_no: "", tag_no: "", owner: "", prod_code: "", status: "", remark: "" }];
//   });

//   const handleChangeInput = (e, i) => {
//     const { name, value } = e.target;
//     const updatedArray = [...table_details];
//     const row = updatedArray[i];
//     if (name === "cyl_no") {
//       row.cyl_no = value;
//       const selectedCyl = cylinder.find(c => c.cylinder_no === value);
//       row.prod_code = selectedCyl ? selectedCyl.prod_code : "";
//       row.cyl_id = selectedCyl ? selectedCyl.cyl_id : "";
//       row.tag_no = selectedCyl ? selectedCyl.tag_no || "" : "";
//       row.owner = selectedCyl ? selectedCyl.owner || "" : "";
//     } else { row[name] = value; }
//     row.sr_no = i + 1;
//     updatedArray[i] = row;
//     settable_details(updatedArray);
//     setIsUpdateArray(prev => !prev);
//   };

//   const handleAddSPQuotationFields = () => {
//     settable_details([...table_details, { sr_no: table_details.length + 1, cyl_no: "", tag_no: "", owner: "", prod_code: "", status: "", remark: "" }]);
//   };

//   const onSubmit = async () => {
//     if (!dcType || (dcType === "depot" && !data.to_depot_id) || (dcType === "supplier" && !data.to_supplier_id) || (!data.vehicle_no && !data.unregistered_vehicle) || (!data.driver_name && !data.unregistered_driver) || !table_details || table_details.length === 0 || table_details.some(row => !row.cyl_no || !row.tag_no)) {
//       setSuccessMessage("Error Occurred! All fields are required"); return;
//     }
//     const dcData = { ...data, locationType: editData ? editData.locationType : dcType, entry_id: editData ? editData.entry_id : null, modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"), modified_by: editData ? userInfo.user_id : null, created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"), created_by: editData ? editData.created_by : userInfo.user_id, table_details: table_details || [], changedUpdatedValue: "edit", short_code, unit_id, to_location: dcType, update_check: checkboxValue, unregistered_driver: data.unregistered_driver, unregistered_vehicle: data.unregistered_vehicle, entry_date: formatDateForAPI(data.entry_date) };
//     try {
//       if (editData) await empty_delivery_challan.editDeleteEmptyDeliverychallan(dcData);
//       else await empty_delivery_challan.addEmptyDeliverychallan(dcData);
//       setSuccessMessage(editData ? "Updated successfully" : "Added successfully");
//       setTimeout(() => navigate(-1), 1000);
//     } catch (error) { console.error("Submit error:", error); setSuccessMessage("Error occurred during submission"); }
//   };

//   const [successMessage, setSuccessMessage] = useState(null);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [selectedCylinders, setSelectedCylinders] = useState([]);
//   const [cylQty, setCylQty] = useState("");

//   const handleOpenDialog = () => setOpenDialog(true);
//   const handleCloseDialog = () => { setOpenDialog(false); setCylQty(""); };

//   const handleCylinderSelect = (cyl) => {
//     const alreadySelected = selectedCylinders.find(c => c.cylinder_no === cyl.cylinder_no);
//     let updatedCylinders;
//     if (alreadySelected) updatedCylinders = selectedCylinders.filter(c => c.cylinder_no !== cyl.cylinder_no);
//     else updatedCylinders = [...selectedCylinders, { cyl_id: cyl.cyl_id, cylinder_no: cyl.cylinder_no, prod_code: cyl.prod_code, status: cyl.status, tag_no: cyl.tag_no || "", owner: cyl.owner || "", remark: "" }];
//     setSelectedCylinders(updatedCylinders);
//     return updatedCylinders.length;
//   };

//   const handleCylQtyChange = (e) => {
//     const qty = e.target.value;
//     setCylQty(qty);
//     if (qty && !isNaN(qty) && qty > 0) {
//       const num = Math.min(parseInt(qty, 10), cylinder.length);
//       setSelectedCylinders(cylinder.slice(0, num).map(cyl => ({ cyl_id: cyl.cyl_id, cylinder_no: cyl.cylinder_no, prod_code: cyl.prod_code, status: "Empty", remark: "" })));
//     } else setSelectedCylinders([]);
//   };

//   const handleDialogConfirm = () => {
//     settable_details(selectedCylinders.map((cyl, index) => ({ sr_no: index + 1, cyl_id: cyl.cyl_id, cyl_no: cyl.cylinder_no, prod_code: cyl.prod_code, status: cyl.status, tag_no: cyl.tag_no || "", owner: cyl.owner || "", remark: cyl.remark })));
//     setIsUpdateArray(prev => !prev);
//     handleCloseDialog();
//   };

//   const handleRemoveCylinder = (index) => {
//     settable_details(table_details.filter((_, i) => i !== index));
//     setIsUpdateArray(prev => !prev);
//   };

//   const handleCheckboxChange = (event) => setCheckboxValue(event.target.checked ? 1 : 0);

//   // Autocomplete renderer helper
//   const acInput = (params, placeholder = "") => (
//     <TextField {...params} size="small" fullWidth placeholder={placeholder} sx={inputSx} />
//   );

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={pageSx}>
//         {/* Breadcrumb */}
//         <Box sx={breadcrumbSx}>
//           <span>Dashboard</span> / <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Empty Challan</span>
//         </Box>

//         {/* Page Header */}
//         <Box sx={pageHeaderSx}>
//           <Box sx={pageTitleSx}>
//             <LocalShippingIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
//             {editData ? "UPDATE" : "ADD"} EMPTY CHALLAN
//           </Box>
//           <Button onClick={() => navigate(-1)} sx={backBtnSx}>
//             <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
//           </Button>
//         </Box>

//         <form onSubmit={handleSubmit(onSubmit)}>
//           {/* ── Section 1: Destination Details ───────────────────────── */}
//           <Box sx={formCardSx}>
//             <Box sx={sectionHeaderSx}>
//               <LocalShippingIcon sx={{ fontSize: 18, color: "#fff" }} />
//               <Typography sx={sectionHeaderTitleSx}>Destination Details</Typography>
//             </Box>
//             <Box sx={formBodySx}>
//               <Grid container spacing={3}>
//                 {/* To Location */}
//                 <Grid item xs={12} md={4}>
//                   <Typography sx={fieldLabelSx}>To Location <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                   <Autocomplete
//                     disablePortal
//                     options={["Depot", "Supplier"]}
//                     value={dcType ? dcType.charAt(0).toUpperCase() + dcType.slice(1) : ""}
//                     onChange={handleTypeChange}
//                     renderInput={(params) => acInput(params, "Select location")}
//                   />
//                 </Grid>

//                 {/* Depot selector */}
//                 {isLocationSelected && dcType === "depot" && (
//                   <Grid item xs={12} md={4}>
//                     <Typography sx={fieldLabelSx}>Depot <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                     <Autocomplete
//                       disablePortal
//                       options={depot}
//                       getOptionLabel={o => typeof o === "string" ? o : o.depot_name || ""}
//                       value={depot.find(i => i.depot_id === data.to_depot_id) || null}
//                       onChange={(e, nv) => handleChange({ target: { name: "to_depot_id", value: nv ? nv.depot_id : "" } })}
//                       renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.depot_name}</MenuItem>}
//                       renderInput={(params) => acInput(params, "Select depot")}
//                     />
//                   </Grid>
//                 )}

//                 {/* Supplier selector */}
//                 {isLocationSelected && dcType === "supplier" && (
//                   <Grid item xs={12} md={4}>
//                     <Typography sx={fieldLabelSx}>Supplier <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                     <Autocomplete
//                       disablePortal
//                       options={supplier}
//                       getOptionLabel={o => typeof o === "string" ? o : o.supplier_name || ""}
//                       value={supplier.find(i => i.supplier_id === data.to_supplier_id) || null}
//                       onChange={(e, nv) => handleChange({ target: { name: "to_supplier_id", value: nv ? nv.supplier_id : "" } })}
//                       renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.supplier_name}</MenuItem>}
//                       renderInput={(params) => acInput(params, "Select supplier")}
//                     />
//                   </Grid>
//                 )}

//                 {/* Entry No */}
//                 <Grid item xs={12} md={4}>
//                   <Typography sx={fieldLabelSx}>Entry No</Typography>
//                   <TextField size="small" fullWidth name="entry_no" value={data.entry_no} sx={readonlyInputSx} InputProps={{ readOnly: true }} placeholder="Auto-generated" />
//                 </Grid>

//                 {/* Entry Date */}
//                 <Grid item xs={12} md={4}>
//                   <Typography sx={fieldLabelSx}>Entry Date <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                   <DatePicker
//                     format="DD/MM/YYYY"
//                     value={dayjs(data.entry_date)}
//                     onChange={nv => handleChange({ target: { name: "entry_date", value: nv ? nv.toDate() : "" } })}
//                     slotProps={{ textField: { size: "small", fullWidth: true, required: true, sx: inputSx } }}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>
//           </Box>

//           {/* ── Section 2: Transport Details ─────────────────────────── */}
//           <Box sx={formCardSx}>
//             <Box sx={sectionHeaderSx}>
//               <LocalShippingIcon sx={{ fontSize: 18, color: "#fff" }} />
//               <Typography sx={sectionHeaderTitleSx}>Transport Details</Typography>
//             </Box>
//             <Box sx={formBodySx}>
//               <Grid container spacing={3}>
//                 {/* Driver Name */}
//                 <Grid item xs={12} md={4}>
//                   <Typography sx={fieldLabelSx}>Driver Name <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                   <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
//                     <Autocomplete
//                       disablePortal fullWidth options={driver || []} clearIcon={false}
//                       getOptionLabel={o => typeof o === "string" ? o : o.driver_name || ""}
//                       value={driver.find(d => d.driver_name === data.driver_name) || null}
//                       onChange={(e, nv) => handleChange({ target: { name: "driver_name", value: nv ? nv.driver_name : "" } })}
//                       renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.driver_name}</MenuItem>}
//                       renderInput={(params) => acInput(params, "Select driver")}
//                     />
//                     <IconButton
//                       onClick={toggleUnregisteredDriver}
//                       sx={{ width: "38px", height: "38px", background: showUnregisteredDriver ? "#EBF4FF" : "#F0F4F8", border: "1.5px solid #E2E8F0", borderRadius: "8px", "&:hover": { background: "#EBF4FF" } }}
//                     >
//                       <AddIcon sx={{ fontSize: "18px", color: "#2063b6" }} />
//                     </IconButton>
//                   </Box>
//                   {showUnregisteredDriver && (
//                     <Box sx={{ mt: 1.5 }}>
//                       <Typography sx={{ ...fieldLabelSx, color: "#718096" }}>Unlisted Driver Name</Typography>
//                       <TextField size="small" fullWidth name="unregistered_driver" value={data.unregistered_driver || ""} onChange={handleChange} sx={inputSx} placeholder="Enter unlisted driver name" />
//                     </Box>
//                   )}
//                 </Grid>

//                 {/* Vehicle No */}
//                 <Grid item xs={12} md={4}>
//                   <Typography sx={fieldLabelSx}>Vehicle No <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                   <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
//                     <Autocomplete
//                       disablePortal fullWidth options={vehicle || []} clearIcon={false}
//                       getOptionLabel={o => typeof o === "string" ? o : o.vehicle_no || ""}
//                       value={vehicle.find(v => v.vehicle_id === data.vehicle_id) || null}
//                       onChange={(e, nv) => { handleChange({ target: { name: "vehicle_id", value: nv ? nv.vehicle_id : "" } }); handleChange({ target: { name: "vehicle_no", value: nv ? nv.vehicle_no : "" } }); }}
//                       renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.vehicle_no}</MenuItem>}
//                       renderInput={(params) => acInput(params, "Select vehicle")}
//                     />
//                     <IconButton
//                       onClick={toggleUnregisteredVehicle}
//                       sx={{ width: "38px", height: "38px", background: showUnregisteredVehicle ? "#EBF4FF" : "#F0F4F8", border: "1.5px solid #E2E8F0", borderRadius: "8px", "&:hover": { background: "#EBF4FF" } }}
//                     >
//                       <AddIcon sx={{ fontSize: "18px", color: "#2063b6" }} />
//                     </IconButton>
//                   </Box>
//                   {showUnregisteredVehicle && (
//                     <Box sx={{ mt: 1.5 }}>
//                       <Typography sx={{ ...fieldLabelSx, color: "#718096" }}>Unlisted Vehicle No</Typography>
//                       <TextField size="small" fullWidth name="unregistered_vehicle" value={data.unregistered_vehicle || ""} onChange={handleChange} sx={inputSx} placeholder="Enter unlisted vehicle number" />
//                     </Box>
//                   )}
//                 </Grid>
//               </Grid>
//             </Box>
//           </Box>

//              <Box sx={{ px: 3, pt: 1, pb: 1 }}>
//               <Button
//                 variant="contained"
//                 onClick={handleOpenDialog}
//                 startIcon={<AddIcon />}
//                 sx={{ background: "#2B6CB0", color: "#fff", fontWeight: 600, fontSize: "13px", px: 3, py: 1, borderRadius: "8px", textTransform: "none", "&:hover": { background: "#04407d" } }}
//               >
//                 Select Cylinders
//               </Button>
//             </Box>

//           {/* ── Section 3: Cylinder List ──────────────────────────────── */}
//           <Box sx={formCardSx}>
//             {/* <Box sx={sectionHeaderSx}>
//               <LocalShippingIcon sx={{ fontSize: 18, color: "#fff" }} />
//               <Typography sx={sectionHeaderTitleSx}>Cylinder List</Typography>
//             </Box> */}

//             {/* Select Cylinders button */}
         

//             <TableContainer>
//               <Table size="small" stickyHeader>
//                 <TableHead>
//                   <tr>
//                     {["Sr No", "Cylinder No", "Tag No", "Owner", "Status", "Remark", "Action"].map(h => (
//                       <th key={h} style={{ background: "#1C3A5E", color: "#fff", fontSize: "12px", fontWeight: 600, fontFamily: "'Inter', Arial, sans-serif", padding: "10px 12px", borderRight: "1px solid rgba(255,255,255,0.1)", whiteSpace: "nowrap" }}>{h}</th>
//                     ))}
//                   </tr>
//                 </TableHead>
//                 <TableBody>
//                   {table_details && table_details.length > 0 && table_details[0].cyl_no !== "" ? (
//                     table_details.map((row, index) => (
//                       <tr
//                         key={index}
//                         style={{ background: index % 2 === 0 ? "#fff" : "#F8FAFC", borderBottom: "1px solid #E2E8F0" }}
//                       >
//                         <td style={{ padding: "8px 12px", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "center" }}>{index + 1}</td>
//                         <td style={{ padding: "8px 12px", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748" }}>{row.cyl_no}</td>
//                         <td style={{ padding: "6px 12px" }}>
//                           <TextField variant="standard" size="small" fullWidth name="tag_no" value={row.tag_no} onChange={e => handleChangeInput(e, index)} InputProps={{ disableUnderline: true, style: { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" } }} />
//                         </td>
//                         <td style={{ padding: "6px 12px" }}>
//                           <TextField variant="standard" size="small" fullWidth name="owner" value={row.owner} onChange={e => handleChangeInput(e, index)} InputProps={{ disableUnderline: true, style: { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" } }} />
//                         </td>
//                         <td style={{ padding: "8px 12px" }}>
//                           <Box sx={{ display: "inline-flex", alignItems: "center", px: 1.5, py: 0.3, borderRadius: "20px", fontSize: "11px", fontWeight: 600, background: row.status === "Full" ? "#FFF5F5" : "#F0FFF4", color: row.status === "Full" ? "#E53E3E" : "#38A169" }}>
//                             {row.status || "Empty"}
//                           </Box>
//                         </td>
//                         <td style={{ padding: "6px 12px" }}>
//                           <TextField variant="standard" size="small" fullWidth name="remark" value={row.remark} onChange={e => handleChangeInput(e, index)} placeholder="Enter remark" InputProps={{ disableUnderline: true, style: { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" } }} />
//                         </td>
//                         <td style={{ padding: "8px 12px", textAlign: "center" }}>
//                           <IconButton size="small" onClick={() => handleRemoveCylinder(index)} sx={{ color: "#E53E3E", "&:hover": { background: "#FFF5F5" }, borderRadius: "6px" }}>
//                             <DeleteForeverIcon sx={{ fontSize: "18px" }} />
//                           </IconButton>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan={7} style={{ padding: "32px", textAlign: "center", color: "#A0AEC0", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" }}>
//                         No cylinders selected. Click "Select Cylinders" to add.
//                       </td>
//                     </tr>
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             {/* Confirm Status Update checkbox (edit mode only) */}
//             {editData && (
//               <Box sx={{ px: 3, pt: 2 }}>
//                 <FormControlLabel
//                   control={<Checkbox checked={checkboxValue === 1} onChange={handleCheckboxChange} size="small" sx={{ color: "#2063b6", '&.Mui-checked': { color: "#2063b6" } }} />}
//                   label={<Typography sx={{ fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748" }}>Confirm Status Update</Typography>}
//                 />
//               </Box>
//             )}

//             {/* Footer Buttons */}
//             <Box sx={formFooterSx}>
//               <Button sx={cancelBtnSx} onClick={() => navigate(-1)}>Cancel</Button>
//               <Button type="submit" sx={saveBtnSx}>
//                 <SaveIcon sx={{ fontSize: 18 }} />
//                 {editData ? "Update" : "Save"}
//               </Button>
//             </Box>
//           </Box>
//         </form>

//         {/* ── Select Cylinders Dialog ───────────────────────────────── */}
//         <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: "14px", border: "1px solid #E2E8F0" } }}>
//           <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//             <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#fff", fontFamily: "'Inter', Arial, sans-serif" }}>
//               Select Cylinders
//               <Box component="span" sx={{ ml: 1.5, px: 1.5, py: 0.3, background: "rgba(255,255,255,0.15)", borderRadius: "20px", fontSize: "12px" }}>
//                 {selectedCylinders.length} selected / {cylinder.length} available
//               </Box>
//             </Typography>
//           </Box>

//           <DialogContent sx={{ pt: 3 }}>
//             <Grid container spacing={1.5}>
//               {cylinder.map((cyl) => {
//                 const isSelected = selectedCylinders.some(c => c.cylinder_no === cyl.cylinder_no);
//                 return (
//                   <Grid item xs={12} sm={6} md={4} lg={3} key={cyl.cylinder_no}>
//                     <Box
//                       onClick={() => handleCylinderSelect(cyl)}
//                       sx={{
//                         background: isSelected ? "linear-gradient(135deg, #2e7d32, #4caf50)" : "linear-gradient(135deg, #1565c0, #2196f3)",
//                         color: "#fff",
//                         cursor: "pointer",
//                         borderRadius: "10px",
//                         padding: "12px 14px",
//                         transition: "all 0.2s ease",
//                         border: isSelected ? "2px solid #81c784" : "2px solid transparent",
//                         "&:hover": { transform: "translateY(-2px)", boxShadow: "0 6px 16px rgba(0,0,0,0.15)" },
//                         boxShadow: isSelected ? "0 4px 12px rgba(76,175,80,0.3)" : "0 2px 8px rgba(33,150,243,0.2)",
//                       }}
//                     >
//                       <Typography sx={{ fontWeight: 700, fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", mb: 0.5 }}>
//                         {cyl.cylinder_no}
//                       </Typography>
//                       <Typography sx={{ fontSize: "11px", opacity: 0.85, fontFamily: "'Inter', Arial, sans-serif" }}>Owner: {cyl.owner || "—"}</Typography>
//                       <Typography sx={{ fontSize: "11px", opacity: 0.85, fontFamily: "'Inter', Arial, sans-serif" }}>Tag: {cyl.tag_no || "—"}</Typography>
//                     </Box>
//                   </Grid>
//                 );
//               })}
//             </Grid>
//           </DialogContent>

//           <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
//             <Button onClick={handleCloseDialog} sx={cancelBtnSx}>Cancel</Button>
//             <Button onClick={handleDialogConfirm} sx={saveBtnSx}>
//               Confirm Selection
//             </Button>
//           </DialogActions>
//         </Dialog>

//         <ReusableSnackbar
//           open={!!successMessage}
//           onClose={(e, reason) => { if (reason !== "clickaway") setSuccessMessage(""); }}
//           message={successMessage}
//           autoHideDuration={2000}
//           vertical="top"
//           horizontal="right"
//         />
//       </Box>
//     </LocalizationProvider>
//   );
// };

// export default AddEmptyDeliveryChllan;



// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Button,
//   MenuItem,
//   Typography,
//   Grid,
//   TableContainer,
//   Table,
//   TableHead,
//   TableBody,
//   IconButton,
//   Dialog,
//   DialogContent,
//   DialogActions,
//   Autocomplete,
//   Checkbox,
//   FormControlLabel,
//   TextField,
// } from "@mui/material";
// import {
//   Breadcrumb,
//   Cancel,
//   CTSinput,
//   StyledTableCell,
//   StyledTableRow,
// } from "../../reusableComponent/Reusables";
// import { useDispatch } from "react-redux";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useForm } from "react-hook-form";
// import AddIcon from "@mui/icons-material/Add";
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import SaveIcon from "@mui/icons-material/Save";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// import dayjs from "dayjs";
// import deliveryChallanService from "../../../services/deliveryChallan.Service";
// import driverMasterService from "../../../services/masters/driverMaster.Service";
// import depotMasterService from "../../../services/masters/depotMaster.Service";
// import productMasterService from "../../../services/masters/productMaster.Service";
// import vehicleMasterService from "../../../services/masters/vehicleMaster.Service";
// import customerMasterService from "../../../services/masters/customerMaster.Service";
// import supplierMasterService from "../../../services/masters/supplierMaster.Service";
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
// import empty_delivery_challan from "../../../services/empty_delivery_challan";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// // ── Shared styles matching PlantAdd ──────────────────────────────────────────

// const pageSx = {
//   background: "#F4F7FB",
//   minHeight: "100vh",
//   padding: "20px 24px 40px",
//   fontFamily: "'Inter', Arial, sans-serif",
// };

// const breadcrumbSx = {
//   fontSize: "12px",
//   color: "#718096",
//   mb: 2,
//   display: "flex",
//   alignItems: "center",
//   gap: "6px",
// };

// const pageHeaderSx = {
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "space-between",
//   mb: 2.5,
// };

// const pageTitleSx = {
//   fontSize: "16px",
//   fontWeight: 700,
//   color: "#000000",
//   display: "flex",
//   alignItems: "center",
//   gap: "10px",
// };

// const backBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "6px",
//   fontSize: "13px",
//   fontWeight: 600,
//   color: "#2B6CB0",
//   padding: "7px 14px",
//   border: "1.5px solid #2B6CB0",
//   borderRadius: "7px",
//   background: "#fff",
//   cursor: "pointer",
//   textTransform: "none",
//   "&:hover": { background: "#E6F1FB" },
// };

// const formCardSx = {
//   background: "#fff",
  
//   border: "1px solid #E2E8F0",
//   overflow: "hidden",
//   mb: 2,
// };

// const sectionHeaderSx = {
//   background: "#1C3A5E",
//   padding: "12px 22px",
//   display: "flex",
//   alignItems: "center",
//   gap: "10px",
// };

// const sectionHeaderTitleSx = {
//   fontSize: "13px",
//   fontWeight: 600,
//   color: "#fff",
//   letterSpacing: "0.3px",
// };

// const formBodySx = { padding: "22px 24px" };

// const fieldLabelSx = {
//   fontSize: "12px",
//   fontWeight: 600,
//   color: "#2063b6",
//   mb: "4px",
//   display: "flex",
//   alignItems: "center",
//   gap: "4px",
// };

// const inputSx = {
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "8px",
//     fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     background: "#fafafa",
//     height: "38px",
//     "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
//     "&:hover fieldset": { borderColor: "#CBD5E0" },
//     "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
//     "&.Mui-focused": { background: "#fff" },
//     "&.Mui-disabled": { background: "#F8FAFC" },
//   },
//   "& input": {
//     color: "#1A202C",
//     fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     "&::placeholder": { color: "#A0AEC0", opacity: 1 },
//   },
//   "& .MuiInputLabel-root": { display: "none" },
// };

// const readonlyInputSx = {
//   ...inputSx,
//   "& .MuiOutlinedInput-root": {
//     ...inputSx["& .MuiOutlinedInput-root"],
//     background: "#F0F4F8",
//   },
// };

// const selectSx = {
//   ...inputSx,
//   "& .MuiOutlinedInput-root": {
//     ...inputSx["& .MuiOutlinedInput-root"],
//     height: "38px",
//   },
// };

// const menuItemSx = { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" };

// const formFooterSx = {
//   padding: "18px 24px",
//   background: "#F8FAFC",
//   borderTop: "1px solid #E2E8F0",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   gap: "10px",
// };

// const saveBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "7px",
//   padding: "0 22px",
//   height: "40px",
//   background: "#4CAF50",
//   color: "#fff",
//   border: "none",
//   fontSize: "14px",
//   fontWeight: 600,
//   textTransform: "none",
//   borderRadius: "8px",
//   fontFamily: "'Inter', Arial, sans-serif",
//   "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
//   "&:active": { transform: "translateY(0)" },
//   "&.Mui-disabled": { background: "#94a3b8", color: "#fff" },
//   transition: "all 0.15s ease",
// };

// const cancelBtnSx = {
//   display: "flex",
//   alignItems: "center",
//   gap: "7px",
//   padding: "0 22px",
//   height: "40px",
//   background: "#E53E3E",
//   color: "#ffffff",
//   border: "none",
//   "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
//   fontSize: "14px",
//   fontWeight: 600,
//   borderRadius: "8px",
//   textTransform: "none",
// };

// const inlineInputSx = {
//   "& .MuiInputBase-root": {
//     fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     background: "transparent",
//     "&:before, &:after": { display: "none" },
//   },
//   "& input": { color: "#2D3748", fontSize: "13px", padding: "4px 0" },
// };

// // ─────────────────────────────────────────────────────────────────────────────

// const AddEmptyDeliveryChllan = () => {
//   const dispatch = useDispatch();
//   const login_details = sessionStorage.getItem("loginUser");
//   const userD = JSON.parse(login_details);
//   const userInfo = userD.result.userInfo;
//   const loggedInDepotId = userInfo.depot_id;
//   const { handleSubmit } = useForm();
//   const urlLocation = useLocation();
//   const editInfo = urlLocation.state;
//   const editData = editInfo && editInfo;
//   const [dcType, setDcType] = useState(editData?.to_location || "");
//   const [isLocationSelected, setIsLocationSelected] = useState(!!editData?.to_location);
//   let navigate = useNavigate();
//   const [driver, setDriver] = useState([]);
//   const [depot, setDepot] = useState([]);
//   const [product, setProduct] = useState([]);
//   const [cylinder, setCylinder] = useState([]);
//   const [vehicle, setVehicle] = useState([]);
//   const [customer, setCustomer] = useState([]);
//   const [supplier, setSupplier] = useState([]);
//   const [depot_name, setDepot_name] = useState([]);
//   const depot_id = userInfo.depot_id;
//   const unit_id = userInfo.depot_id || userInfo.plant_id;
//   const short_code = userInfo.depot_short_code || userInfo.plant_short_code;
//   const [checkboxValue, setCheckboxValue] = useState(editData ? editData.update_check || 0 : 0);
//   const [showUnregisteredDriver, setShowUnregisteredDriver] = useState(!!editData?.unregistered_driver);
//   const [showUnregisteredVehicle, setShowUnregisteredVehicle] = useState(!!editData?.unregistered_vehicle);

//   const formatDateForDisplay = (date) => {
//     if (!date) return "";
//     return dayjs(date).isValid() ? dayjs(date).format("DD/MM/YYYY") : "";
//   };

//   const formatDateForAPI = (date) => {
//     if (!date) return "";
//     return dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : "";
//   };

//   const [data, setData] = useState({
//     entry_no: editData ? editData.entry_no : "",
//     entry_date: editData ? formatDateForAPI(editData.entry_date) : formatDateForAPI(new Date()),
//     from_depot: editData ? editData.from_depot : "",
//     to_supplier: editData ? editData.to_supplier : "",
//     to_supplier_id: editData ? editData.to_supplier_id : "",
//     to_customer: editData ? editData.to_customer : "",
//     to_customer_id: editData ? editData.to_customer_id : "",
//     vehicle_no: editData ? editData.vehicle_no : "",
//     vehicle_id: editData ? editData.vehicle_id : "",
//     driver_name: editData ? editData.driver_name : "",
//     driver_id: editData ? editData.driver_id : "",
//     table_details: editData ? editData.table_details : "",
//     to_depot: editData ? editData.to_depot : "",
//     to_depot_id: editData ? editData.to_depot_id : "",
//     fin_year: editData ? editData.fin_year : "",
//     from_depot_id: unit_id,
//     unregistered_driver: editData ? editData.unregistered_driver : "",
//     unregistered_vehicle: editData ? editData.unregistered_vehicle : "",
//     to_location: editData ? editData.to_location : "",
//   });

//   const toggleUnregisteredDriver = () => {
//     setShowUnregisteredDriver((prev) => !prev);
//     if (showUnregisteredDriver) {
//       handleChange({ target: { name: "unregistered_driver", value: "" } });
//     }
//   };

//   const toggleUnregisteredVehicle = () => {
//     setShowUnregisteredVehicle((prev) => !prev);
//     if (showUnregisteredVehicle) {
//       handleChange({ target: { name: "unregistered_vehicle", value: "" } });
//     }
//   };

//   useEffect(() => {
//     async function fetchData() {
//       try {
//         const [driverData, depotData, productData, customerData, vehicleData, cylinderData, delivercylindrData, DdepotData, DcustomerData, supplierData] = await Promise.all([
//           driverMasterService.getDriverList({ page: 0, size: 999, searchKey: "" }),
//           depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
//           productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
//           customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
//           vehicleMasterService.getVehicleList({ page: 0, size: 999, searchKey: "" }),
//           cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
//           empty_delivery_challan.getEmptyDeliveryCylinderList(depot_id),
//           empty_delivery_challan.getEmptyChallandepotList(depot_id),
//           empty_delivery_challan.getEmptyChallanCustomerList(depot_id),
//           supplierMasterService.getSupplierList({ page: 0, size: 999, searchKey: "" }),
//         ]);
//         setDepot(DdepotData);
//         setDriver(driverData);
//         setProduct(productData);
//         setCustomer(DcustomerData);
//         setVehicle(vehicleData);
//         setCylinder(delivercylindrData);
//         setDepot_name(depotData);
//         setSupplier(supplierData);

//         if (editData) {
//           try {
//             const tableDetails = JSON.parse(editData.table_details);
//             const initialCylinders = tableDetails.map((row, index) => ({ sr_no: index + 1, cyl_no: row.cyl_no, prod_code: row.prod_code, status: row.status, tag_no: row.tag_no || "", owner: row.owner || "", remark: row.remark || "" }));
//             setSelectedCylinders(initialCylinders);
//             settable_details(initialCylinders);
//           } catch (error) { console.error("Failed to parse table_details:", error); }
//         }
//       } catch (error) { console.error("Data fetching failed", error); }
//     }
//     fetchData();
//   }, [editData, depot_id]);

//   useEffect(() => {
//     if (editData) {
//       let to_location = editData.to_location || "";
//       if (!to_location) {
//         if (editData.to_depot_id) to_location = "depot";
//         else if (editData.to_supplier_id) to_location = "supplier";
//       }
//       setDcType(to_location);
//       setIsLocationSelected(!!to_location);
//       setData({ entry_no: editData.entry_no || "", entry_date: formatDateForAPI(editData.entry_date), from_depot: editData.from_depot || "", from_depot_id: editData.from_depot_id || "", to_customer: editData.customer_name || "", to_customer_id: editData.to_customer_id || "", to_depot: editData.depot_name || "", to_depot_id: editData.to_depot_id || "", to_supplier: editData.supplier_name || "", to_supplier_id: editData.to_supplier_id || "", to_location: to_location, vehicle_no: editData.vehicle_no || "", vehicle_id: editData.vehicle_id || "", driver_name: editData.driver_name || "", driver_id: editData.driver_id || "", table_details: editData.table_details || [], fin_year: editData.fin_year || "", unit_id: editData.unit_id || "", short_code: editData.short_code || "", unregistered_driver: editData.unregistered_driver || "", unregistered_vehicle: editData.unregistered_vehicle || "" });
//       if (editData.table_details) {
//         let details = editData.table_details;
//         if (typeof details === "string") { try { details = JSON.parse(details); } catch (e) { details = []; } }
//         settable_details(details);
//       }
//     }
//   }, [editData]);

//   const handleTypeChange = (event, newValue) => {
//     const value = newValue ? newValue.toLowerCase() : "";
//     setDcType(value);
//     setIsLocationSelected(!!value);
//     setData((prevData) => ({ ...prevData, to_location: value, type: value, to_customer: "", to_customer_id: "", to_depot: "", to_depot_id: "", to_supplier: "", to_supplier_id: "" }));
//   };

//   const handleChange = ({ target }) => {
//     const { name, value } = target;
//     let updatedFields = { [name]: value };
//     if (name === "entry_date") {
//       updatedFields.entry_date = formatDateForAPI(value);
//       const selectedDate = dayjs(value);
//       if (selectedDate.isValid()) {
//         const month = selectedDate.month(), year = selectedDate.year();
//         updatedFields.fin_year = month >= 3 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
//       }
//     } else if (name === "from_depot_id") {
//       const sel = depot.find(d => d.depot_id === value);
//       if (sel) { updatedFields.from_depot = sel.depot_name; updatedFields.from_depot_id = sel.depot_id; }
//     } else if (name === "to_depot_id") {
//       const sel = depot.find(d => d.depot_id === value);
//       if (sel) { updatedFields.to_depot = sel.depot_name; updatedFields.to_depot_id = sel.depot_id; }
//     } else if (name === "to_customer_id") {
//       const sel = customer.find(c => c.cust_id === value);
//       if (sel) { updatedFields.to_customer = sel.cust_name; updatedFields.to_customer_id = sel.cust_id; }
//     } else if (name === "to_supplier_id") {
//       const sel = supplier.find(s => s.supplier_id === value);
//       if (sel) { updatedFields.to_supplier = sel.supplier_name; updatedFields.to_supplier_id = sel.supplier_id; }
//     } else if (name === "driver_name") {
//       const sel = driver.find(d => d.driver_name === value);
//       updatedFields.driver_id = sel ? sel.driver_id : "";
//       if (value) { updatedFields.unregistered_driver = ""; setShowUnregisteredDriver(false); }
//     } else if (name === "vehicle_no") {
//       const sel = vehicle.find(v => v.vehicle_no === value);
//       updatedFields.vehicle_id = sel ? sel.vehicle_id : "";
//       if (value) { updatedFields.unregistered_vehicle = ""; setShowUnregisteredVehicle(false); }
//     } else if (name === "unregistered_driver" && value) {
//       updatedFields.driver_name = ""; updatedFields.driver_id = "";
//     } else if (name === "unregistered_vehicle" && value) {
//       updatedFields.vehicle_no = ""; updatedFields.vehicle_id = "";
//     }
//     setData(prevData => ({ ...prevData, ...updatedFields }));
//   };

//   const [isUpdateArray, setIsUpdateArray] = useState(false);
//   const [table_details, settable_details] = useState(() => {
//     if (editData) {
//       try {
//         const p = JSON.parse(editData.table_details);
//         return p.map((row, index) => ({ sr_no: index + 1, cyl_no: row.cyl_no || "", prod_code: row.prod_code || "", status: row.status || "Empty", tag_no: row.tag_no || "", owner: row.owner || "", remark: row.remark || "" }));
//       } catch (e) { return [{ sr_no: 1, cyl_no: "", tag_no: "", owner: "", prod_code: "", status: "", remark: "" }]; }
//     }
//     return [{ sr_no: 1, cyl_no: "", tag_no: "", owner: "", prod_code: "", status: "", remark: "" }];
//   });

//   const handleChangeInput = (e, i) => {
//     const { name, value } = e.target;
//     const updatedArray = [...table_details];
//     const row = updatedArray[i];
//     if (name === "cyl_no") {
//       row.cyl_no = value;
//       const selectedCyl = cylinder.find(c => c.cylinder_no === value);
//       row.prod_code = selectedCyl ? selectedCyl.prod_code : "";
//       row.cyl_id = selectedCyl ? selectedCyl.cyl_id : "";
//       row.tag_no = selectedCyl ? selectedCyl.tag_no || "" : "";
//       row.owner = selectedCyl ? selectedCyl.owner || "" : "";
//     } else { row[name] = value; }
//     row.sr_no = i + 1;
//     updatedArray[i] = row;
//     settable_details(updatedArray);
//     setIsUpdateArray(prev => !prev);
//   };

//   const handleAddSPQuotationFields = () => {
//     settable_details([...table_details, { sr_no: table_details.length + 1, cyl_no: "", tag_no: "", owner: "", prod_code: "", status: "", remark: "" }]);
//   };

//   const onSubmit = async () => {
//     if (!dcType || (dcType === "depot" && !data.to_depot_id) || (dcType === "supplier" && !data.to_supplier_id) || (!data.vehicle_no && !data.unregistered_vehicle) || (!data.driver_name && !data.unregistered_driver) || !table_details || table_details.length === 0 || table_details.some(row => !row.cyl_no || !row.tag_no)) {
//       setSuccessMessage("Error Occurred! All fields are required"); return;
//     }
//     const dcData = { ...data, locationType: editData ? editData.locationType : dcType, entry_id: editData ? editData.entry_id : null, modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"), modified_by: editData ? userInfo.user_id : null, created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"), created_by: editData ? editData.created_by : userInfo.user_id, table_details: table_details || [], changedUpdatedValue: "edit", short_code, unit_id, to_location: dcType, update_check: checkboxValue, unregistered_driver: data.unregistered_driver, unregistered_vehicle: data.unregistered_vehicle, entry_date: formatDateForAPI(data.entry_date) };
//     try {
//       if (editData) await empty_delivery_challan.editDeleteEmptyDeliverychallan(dcData);
//       else await empty_delivery_challan.addEmptyDeliverychallan(dcData);
//       setSuccessMessage(editData ? "Updated successfully" : "Added successfully");
//       setTimeout(() => navigate(-1), 1000);
//     } catch (error) { console.error("Submit error:", error); setSuccessMessage("Error occurred during submission"); }
//   };

//   const [successMessage, setSuccessMessage] = useState(null);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [selectedCylinders, setSelectedCylinders] = useState([]);
//   const [cylQty, setCylQty] = useState("");

//   const handleOpenDialog = () => setOpenDialog(true);
//   const handleCloseDialog = () => { setOpenDialog(false); setCylQty(""); };

//   const handleCylinderSelect = (cyl) => {
//     const alreadySelected = selectedCylinders.find(c => c.cylinder_no === cyl.cylinder_no);
//     let updatedCylinders;
//     if (alreadySelected) updatedCylinders = selectedCylinders.filter(c => c.cylinder_no !== cyl.cylinder_no);
//     else updatedCylinders = [...selectedCylinders, { cyl_id: cyl.cyl_id, cylinder_no: cyl.cylinder_no, prod_code: cyl.prod_code, status: cyl.status, tag_no: cyl.tag_no || "", owner: cyl.owner || "", remark: "" }];
//     setSelectedCylinders(updatedCylinders);
//     return updatedCylinders.length;
//   };

//   const handleCylQtyChange = (e) => {
//     const qty = e.target.value;
//     setCylQty(qty);
//     if (qty && !isNaN(qty) && qty > 0) {
//       const num = Math.min(parseInt(qty, 10), cylinder.length);
//       setSelectedCylinders(cylinder.slice(0, num).map(cyl => ({ cyl_id: cyl.cyl_id, cylinder_no: cyl.cylinder_no, prod_code: cyl.prod_code, status: "Empty", remark: "" })));
//     } else setSelectedCylinders([]);
//   };

//   const handleDialogConfirm = () => {
//     settable_details(selectedCylinders.map((cyl, index) => ({ sr_no: index + 1, cyl_id: cyl.cyl_id, cyl_no: cyl.cylinder_no, prod_code: cyl.prod_code, status: cyl.status, tag_no: cyl.tag_no || "", owner: cyl.owner || "", remark: cyl.remark })));
//     setIsUpdateArray(prev => !prev);
//     handleCloseDialog();
//   };

//   const handleRemoveCylinder = (index) => {
//     settable_details(table_details.filter((_, i) => i !== index));
//     setIsUpdateArray(prev => !prev);
//   };

//   const handleCheckboxChange = (event) => setCheckboxValue(event.target.checked ? 1 : 0);

//   // Autocomplete renderer helper
//   const acInput = (params, placeholder = "") => (
//     <TextField {...params} size="small" fullWidth placeholder={placeholder} sx={inputSx} />
//   );

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={pageSx}>
//         {/* Breadcrumb */}
//         <Box sx={breadcrumbSx}>
//           <span>Dashboard</span> / <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Empty Challan</span>
//         </Box>

//         {/* Page Header */}
//         <Box sx={pageHeaderSx}>
//           <Box sx={pageTitleSx}>
//             <LocalShippingIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
//             {editData ? "UPDATE" : "ADD"} EMPTY CHALLAN
//           </Box>
//           <Button onClick={() => navigate(-1)} sx={backBtnSx}>
//             <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
//           </Button>
//         </Box>

//         <form onSubmit={handleSubmit(onSubmit)}>
//           {/* ── Section: EmptyChallanDetails (merged Destination + Transport) ───────────────────────── */}
//           <Box sx={formCardSx}>
//             <Box sx={sectionHeaderSx}>
//               <LocalShippingIcon sx={{ fontSize: 18, color: "#fff" }} />
//               <Typography sx={sectionHeaderTitleSx}>Empty Challan Details</Typography>
//             </Box>
//             <Box sx={formBodySx}>
//               <Grid container spacing={3}>
//                 {/* To Location */}
//                 <Grid item xs={12} md={4}>
//                   <Typography sx={fieldLabelSx}>To Location <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                   <Autocomplete
//                     disablePortal
//                     options={["Depot", "Supplier"]}
//                     value={dcType ? dcType.charAt(0).toUpperCase() + dcType.slice(1) : ""}
//                     onChange={handleTypeChange}
//                     renderInput={(params) => acInput(params, "Select location")}
//                   />
//                 </Grid>

//                 {/* Depot selector */}
//                 {isLocationSelected && dcType === "depot" && (
//                   <Grid item xs={12} md={4}>
//                     <Typography sx={fieldLabelSx}>Depot <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                     <Autocomplete
//                       disablePortal
//                       options={depot}
//                       getOptionLabel={o => typeof o === "string" ? o : o.depot_name || ""}
//                       value={depot.find(i => i.depot_id === data.to_depot_id) || null}
//                       onChange={(e, nv) => handleChange({ target: { name: "to_depot_id", value: nv ? nv.depot_id : "" } })}
//                       renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.depot_name}</MenuItem>}
//                       renderInput={(params) => acInput(params, "Select depot")}
//                     />
//                   </Grid>
//                 )}

//                 {/* Supplier selector */}
//                 {isLocationSelected && dcType === "supplier" && (
//                   <Grid item xs={12} md={4}>
//                     <Typography sx={fieldLabelSx}>Supplier <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                     <Autocomplete
//                       disablePortal
//                       options={supplier}
//                       getOptionLabel={o => typeof o === "string" ? o : o.supplier_name || ""}
//                       value={supplier.find(i => i.supplier_id === data.to_supplier_id) || null}
//                       onChange={(e, nv) => handleChange({ target: { name: "to_supplier_id", value: nv ? nv.supplier_id : "" } })}
//                       renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.supplier_name}</MenuItem>}
//                       renderInput={(params) => acInput(params, "Select supplier")}
//                     />
//                   </Grid>
//                 )}

//                 {/* Entry No */}
//                 <Grid item xs={12} md={4}>
//                   <Typography sx={fieldLabelSx}>Entry No</Typography>
//                   <TextField size="small" fullWidth name="entry_no" value={data.entry_no} sx={readonlyInputSx} InputProps={{ readOnly: true }} placeholder="Auto-generated" />
//                 </Grid>

//                 {/* Entry Date */}
//                 <Grid item xs={12} md={4}>
//                   <Typography sx={fieldLabelSx}>Entry Date <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                   <DatePicker
//                     format="DD/MM/YYYY"
//                     value={dayjs(data.entry_date)}
//                     onChange={nv => handleChange({ target: { name: "entry_date", value: nv ? nv.toDate() : "" } })}
//                     slotProps={{ textField: { size: "small", fullWidth: true, required: true, sx: inputSx } }}
//                   />
//                 </Grid>

//                 {/* Driver Name */}
//                 <Grid item xs={12} md={4}>
//                   <Typography sx={fieldLabelSx}>Driver Name <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                   <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
//                     <Autocomplete
//                       disablePortal fullWidth options={driver || []} clearIcon={false}
//                       getOptionLabel={o => typeof o === "string" ? o : o.driver_name || ""}
//                       value={driver.find(d => d.driver_name === data.driver_name) || null}
//                       onChange={(e, nv) => handleChange({ target: { name: "driver_name", value: nv ? nv.driver_name : "" } })}
//                       renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.driver_name}</MenuItem>}
//                       renderInput={(params) => acInput(params, "Select driver")}
//                     />
//                     <IconButton
//                       onClick={toggleUnregisteredDriver}
//                       sx={{ width: "38px", height: "38px", background: showUnregisteredDriver ? "#EBF4FF" : "#F0F4F8", border: "1.5px solid #E2E8F0", borderRadius: "8px", "&:hover": { background: "#EBF4FF" } }}
//                     >
//                       <AddIcon sx={{ fontSize: "18px", color: "#2063b6" }} />
//                     </IconButton>
//                   </Box>
//                   {showUnregisteredDriver && (
//                     <Box sx={{ mt: 1.5 }}>
//                       <Typography sx={{ ...fieldLabelSx, color: "#718096" }}>Unlisted Driver Name</Typography>
//                       <TextField size="small" fullWidth name="unregistered_driver" value={data.unregistered_driver || ""} onChange={handleChange} sx={inputSx} placeholder="Enter unlisted driver name" />
//                     </Box>
//                   )}
//                 </Grid>

//                 {/* Vehicle No */}
//                 <Grid item xs={12} md={4}>
//                   <Typography sx={fieldLabelSx}>Vehicle No <span style={{ color: "#E53E3E" }}>*</span></Typography>
//                   <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
//                     <Autocomplete
//                       disablePortal fullWidth options={vehicle || []} clearIcon={false}
//                       getOptionLabel={o => typeof o === "string" ? o : o.vehicle_no || ""}
//                       value={vehicle.find(v => v.vehicle_id === data.vehicle_id) || null}
//                       onChange={(e, nv) => { handleChange({ target: { name: "vehicle_id", value: nv ? nv.vehicle_id : "" } }); handleChange({ target: { name: "vehicle_no", value: nv ? nv.vehicle_no : "" } }); }}
//                       renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.vehicle_no}</MenuItem>}
//                       renderInput={(params) => acInput(params, "Select vehicle")}
//                     />
//                     <IconButton
//                       onClick={toggleUnregisteredVehicle}
//                       sx={{ width: "38px", height: "38px", background: showUnregisteredVehicle ? "#EBF4FF" : "#F0F4F8", border: "1.5px solid #E2E8F0", borderRadius: "8px", "&:hover": { background: "#EBF4FF" } }}
//                     >
//                       <AddIcon sx={{ fontSize: "18px", color: "#2063b6" }} />
//                     </IconButton>
//                   </Box>
//                   {showUnregisteredVehicle && (
//                     <Box sx={{ mt: 1.5 }}>
//                       <Typography sx={{ ...fieldLabelSx, color: "#718096" }}>Unlisted Vehicle No</Typography>
//                       <TextField size="small" fullWidth name="unregistered_vehicle" value={data.unregistered_vehicle || ""} onChange={handleChange} sx={inputSx} placeholder="Enter unlisted vehicle number" />
//                     </Box>
//                   )}
//                 </Grid>
//               </Grid>
//             </Box>
//           </Box>

//           <Box sx={{ px: 3, pt: 1, pb: 1 }}>
//             <Button
//               variant="contained"
//               onClick={handleOpenDialog}
//               startIcon={<AddIcon />}
//               sx={{ background: "#2B6CB0", color: "#fff", fontWeight: 600, fontSize: "13px", px: 3, py: 1, borderRadius: "8px", textTransform: "none", "&:hover": { background: "#04407d" } }}
//             >
//               Select Cylinders
//             </Button>
//           </Box>

//           {/* ── Section: Cylinder List ──────────────────────────────── */}
//           <Box sx={formCardSx}>
//             <TableContainer>
//               <Table size="small" stickyHeader>
//                 <TableHead>
//                   <tr>
//                     {["Sr No", "Cylinder No", "Tag No", "Owner", "Status", "Remark", "Action"].map(h => (
//                       <th key={h} style={{ background: "#1C3A5E", color: "#fff", fontSize: "12px", fontWeight: 600, fontFamily: "'Inter', Arial, sans-serif", padding: "10px 12px", borderRight: "1px solid rgba(255,255,255,0.1)", whiteSpace: "nowrap" }}>{h}</th>
//                     ))}
//                   </tr>
//                 </TableHead>
//                 <TableBody>
//                   {table_details && table_details.length > 0 && table_details[0].cyl_no !== "" ? (
//                     table_details.map((row, index) => (
//                       <tr
//                         key={index}
//                         style={{ background: index % 2 === 0 ? "#fff" : "#F8FAFC", borderBottom: "1px solid #E2E8F0" }}
//                       >
//                         <td style={{ padding: "8px 12px", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "center" }}>{index + 1}</td>
//                         <td style={{ padding: "8px 12px", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748" }}>{row.cyl_no}</td>
//                         <td style={{ padding: "6px 12px" }}>
//                           <TextField variant="standard" size="small" fullWidth name="tag_no" value={row.tag_no} onChange={e => handleChangeInput(e, index)} InputProps={{ disableUnderline: true, style: { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" } }} />
//                         </td>
//                         <td style={{ padding: "6px 12px" }}>
//                           <TextField variant="standard" size="small" fullWidth name="owner" value={row.owner} onChange={e => handleChangeInput(e, index)} InputProps={{ disableUnderline: true, style: { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" } }} />
//                         </td>
//                         <td style={{ padding: "8px 12px" }}>
//                           <Box sx={{ display: "inline-flex", alignItems: "center", px: 1.5, py: 0.3, borderRadius: "20px", fontSize: "11px", fontWeight: 600, background: row.status === "Full" ? "#FFF5F5" : "#F0FFF4", color: row.status === "Full" ? "#E53E3E" : "#38A169" }}>
//                             {row.status || "Empty"}
//                           </Box>
//                         </td>
//                         <td style={{ padding: "6px 12px" }}>
//                           <TextField variant="standard" size="small" fullWidth name="remark" value={row.remark} onChange={e => handleChangeInput(e, index)} placeholder="Enter remark" InputProps={{ disableUnderline: true, style: { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" } }} />
//                         </td>
//                         <td style={{ padding: "8px 12px", textAlign: "center" }}>
//                           <IconButton size="small" onClick={() => handleRemoveCylinder(index)} sx={{ color: "#E53E3E", "&:hover": { background: "#FFF5F5" }, borderRadius: "6px" }}>
//                             <DeleteForeverIcon sx={{ fontSize: "18px" }} />
//                           </IconButton>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan={7} style={{ padding: "32px", textAlign: "center", color: "#A0AEC0", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" }}>
//                         No cylinders selected. Click "Select Cylinders" to add.
//                       </td>
//                     </tr>
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             {/* Confirm Status Update checkbox (edit mode only) */}
//             {editData && (
//               <Box sx={{ px: 3, pt: 2 }}>
//                 <FormControlLabel
//                   control={<Checkbox checked={checkboxValue === 1} onChange={handleCheckboxChange} size="small" sx={{ color: "#2063b6", '&.Mui-checked': { color: "#2063b6" } }} />}
//                   label={<Typography sx={{ fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748" }}>Confirm Status Update</Typography>}
//                 />
//               </Box>
//             )}

//             {/* Footer Buttons */}
//             <Box sx={formFooterSx}>
//               <Button sx={cancelBtnSx} onClick={() => navigate(-1)}>Cancel</Button>
//               <Button type="submit" sx={saveBtnSx}>
//                 <SaveIcon sx={{ fontSize: 18 }} />
//                 {editData ? "Update" : "Save"}
//               </Button>
//             </Box>
//           </Box>
//         </form>

//         {/* ── Select Cylinders Dialog ───────────────────────────────── */}
//         <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: "14px", border: "1px solid #E2E8F0" } }}>
//           <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//             <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#fff", fontFamily: "'Inter', Arial, sans-serif" }}>
//               Select Cylinders
//               <Box component="span" sx={{ ml: 1.5, px: 1.5, py: 0.3, background: "rgba(255,255,255,0.15)", borderRadius: "20px", fontSize: "12px" }}>
//                 {selectedCylinders.length} selected / {cylinder.length} available
//               </Box>
//             </Typography>
//           </Box>

//           <DialogContent sx={{ pt: 3 }}>
//             <Grid container spacing={1.5}>
//               {cylinder.map((cyl) => {
//                 const isSelected = selectedCylinders.some(c => c.cylinder_no === cyl.cylinder_no);
//                 return (
//                   <Grid item xs={12} sm={6} md={4} lg={3} key={cyl.cylinder_no}>
//                     <Box
//                       onClick={() => handleCylinderSelect(cyl)}
//                       sx={{
//                         background: isSelected ? "linear-gradient(135deg, #2e7d32, #4caf50)" : "linear-gradient(135deg, #1565c0, #2196f3)",
//                         color: "#fff",
//                         cursor: "pointer",
//                         borderRadius: "10px",
//                         padding: "12px 14px",
//                         transition: "all 0.2s ease",
//                         border: isSelected ? "2px solid #81c784" : "2px solid transparent",
//                         "&:hover": { transform: "translateY(-2px)", boxShadow: "0 6px 16px rgba(0,0,0,0.15)" },
//                         boxShadow: isSelected ? "0 4px 12px rgba(76,175,80,0.3)" : "0 2px 8px rgba(33,150,243,0.2)",
//                       }}
//                     >
//                       <Typography sx={{ fontWeight: 700, fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", mb: 0.5 }}>
//                         {cyl.cylinder_no}
//                       </Typography>
//                       <Typography sx={{ fontSize: "11px", opacity: 0.85, fontFamily: "'Inter', Arial, sans-serif" }}>Owner: {cyl.owner || "—"}</Typography>
//                       <Typography sx={{ fontSize: "11px", opacity: 0.85, fontFamily: "'Inter', Arial, sans-serif" }}>Tag: {cyl.tag_no || "—"}</Typography>
//                     </Box>
//                   </Grid>
//                 );
//               })}
//             </Grid>
//           </DialogContent>

//           <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
//             <Button onClick={handleCloseDialog} sx={cancelBtnSx}>Cancel</Button>
//             <Button onClick={handleDialogConfirm} sx={saveBtnSx}>
//               Confirm Selection
//             </Button>
//           </DialogActions>
//         </Dialog>

//         <ReusableSnackbar
//           open={!!successMessage}
//           onClose={(e, reason) => { if (reason !== "clickaway") setSuccessMessage(""); }}
//           message={successMessage}
//           autoHideDuration={2000}
//           vertical="top"
//           horizontal="right"
//         />
//       </Box>
//     </LocalizationProvider>
//   );
// };

// export default AddEmptyDeliveryChllan;


import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  MenuItem,
  Typography,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
  Autocomplete,
  Checkbox,
  FormControlLabel,
  TextField,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import dayjs from "dayjs";
import deliveryChallanService from "../../../services/deliveryChallan.Service";
import driverMasterService from "../../../services/masters/driverMaster.Service";
import depotMasterService from "../../../services/masters/depotMaster.Service";
import productMasterService from "../../../services/masters/productMaster.Service";
import vehicleMasterService from "../../../services/masters/vehicleMaster.Service";
import customerMasterService from "../../../services/masters/customerMaster.Service";
import supplierMasterService from "../../../services/masters/supplierMaster.Service";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
import empty_delivery_challan from "../../../services/empty_delivery_challan";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// ── Shared styles ─────────────────────────────────────────────────────────────

const pageSx = {
  background: "#F4F7FB",
  minHeight: "100vh",
  padding: "20px 24px 40px",
  fontFamily: "'Inter', Arial, sans-serif",
};

const breadcrumbSx = {
  fontSize: "12px",
  color: "#718096",
  mb: 2,
  display: "flex",
  alignItems: "center",
  gap: "6px",
};

const pageHeaderSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 2.5,
};

const pageTitleSx = {
  fontSize: "16px",
  fontWeight: 700,
  color: "#000000",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const backBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  fontSize: "13px",
  fontWeight: 600,
  color: "#2B6CB0",
  padding: "7px 14px",
  border: "1.5px solid #2B6CB0",
  borderRadius: "7px",
  background: "#fff",
  cursor: "pointer",
  textTransform: "none",
  "&:hover": { background: "#E6F1FB" },
};

const formCardSx = {
  background: "#fff",
  border: "1px solid #E2E8F0",
  overflow: "hidden",
  mb: 2,
};

const sectionHeaderSx = {
  background: "#1C3A5E",
  padding: "12px 22px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const sectionHeaderTitleSx = {
  fontSize: "13px",
  fontWeight: 600,
  color: "#fff",
  letterSpacing: "0.3px",
};

const formBodySx = { padding: "20px 22px" };

const fieldLabelSx = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#2063b6",
  mb: "4px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
};

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    background: "#fafafa",
    height: "36px",
    "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
    "&.Mui-focused": { background: "#fff" },
    "&.Mui-disabled": { background: "#F8FAFC" },
  },
  "& input": {
    color: "#1A202C",
    fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    "&::placeholder": { color: "#A0AEC0", opacity: 1 },
  },
  "& .MuiInputLabel-root": { display: "none" },
};

const readonlyInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    background: "#F0F4F8",
  },
};

const selectSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    height: "36px",
  },
};

const menuItemSx = { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" };

const formFooterSx = {
  padding: "18px 24px",
  background: "#F8FAFC",
  borderTop: "1px solid #E2E8F0",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "10px",
};

const saveBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "40px",
  background: "#4CAF50",
  color: "#fff",
  border: "none",
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "none",
  borderRadius: "8px",
  fontFamily: "'Inter', Arial, sans-serif",
  "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
  "&:active": { transform: "translateY(0)" },
  "&.Mui-disabled": { background: "#94a3b8", color: "#fff" },
  transition: "all 0.15s ease",
};

const cancelBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "40px",
  background: "#E53E3E",
  color: "#ffffff",
  border: "none",
  "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
  fontSize: "14px",
  fontWeight: 600,
  borderRadius: "8px",
  textTransform: "none",
};

// ─────────────────────────────────────────────────────────────────────────────

const AddEmptyDeliveryChllan = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem("loginUser");
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;
  const loggedInDepotId = userInfo.depot_id;
  const { handleSubmit } = useForm();
  const urlLocation = useLocation();
  const editInfo = urlLocation.state;
  const editData = editInfo && editInfo;
 const [dcType, setDcType] = useState(editData?.to_location || "depot");
const [isLocationSelected, setIsLocationSelected] = useState(!!editData?.to_location || true);
  let navigate = useNavigate();
  const [driver, setDriver] = useState([]);
  const [depot, setDepot] = useState([]);
  const [product, setProduct] = useState([]);
  const [cylinder, setCylinder] = useState([]);
  const [vehicle, setVehicle] = useState([]);
  const [customer, setCustomer] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [depot_name, setDepot_name] = useState([]);
  const depot_id = userInfo.depot_id;
  const unit_id = userInfo.depot_id || userInfo.plant_id;
  const short_code = userInfo.depot_short_code || userInfo.plant_short_code;
  const [checkboxValue, setCheckboxValue] = useState(editData ? editData.update_check || 0 : 0);
  const [showUnregisteredDriver, setShowUnregisteredDriver] = useState(!!editData?.unregistered_driver);
  const [showUnregisteredVehicle, setShowUnregisteredVehicle] = useState(!!editData?.unregistered_vehicle);

  const formatDateForDisplay = (date) => {
    if (!date) return "";
    return dayjs(date).isValid() ? dayjs(date).format("DD/MM/YYYY") : "";
  };

  const formatDateForAPI = (date) => {
    if (!date) return "";
    return dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : "";
  };

  const [data, setData] = useState({
    entry_no: editData ? editData.entry_no : "",
    entry_date: editData ? formatDateForAPI(editData.entry_date) : formatDateForAPI(new Date()),
    from_depot: editData ? editData.from_depot : "",
    to_supplier: editData ? editData.to_supplier : "",
    to_supplier_id: editData ? editData.to_supplier_id : "",
    to_customer: editData ? editData.to_customer : "",
    to_customer_id: editData ? editData.to_customer_id : "",
   
    vehicle_no: editData ? editData.vehicle_no : "",
driver_name: editData ? editData.driver_name : "",
    
    table_details: editData ? editData.table_details : "",
    to_depot: editData ? editData.to_depot : "",
    to_depot_id: editData ? editData.to_depot_id : "",
    fin_year: editData ? editData.fin_year : "",
    from_depot_id: unit_id,
   
  to_location: editData ? editData.to_location : "depot",
  });

  const toggleUnregisteredDriver = () => {
    setShowUnregisteredDriver((prev) => !prev);
    if (showUnregisteredDriver) {
      handleChange({ target: { name: "unregistered_driver", value: "" } });
    }
  };

  const toggleUnregisteredVehicle = () => {
    setShowUnregisteredVehicle((prev) => !prev);
    if (showUnregisteredVehicle) {
      handleChange({ target: { name: "unregistered_vehicle", value: "" } });
    }
  };
useEffect(() => {
  async function fetchData() {
    try {
      const [driverData, depotData, productData, customerData, vehicleData, cylinderData, delivercylindrData, DdepotData, DcustomerData, supplierData] = await Promise.all([
        driverMasterService.getDriverList({ page: 0, size: 999, searchKey: "" }),
        depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
        productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
        customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
        vehicleMasterService.getVehicleList({ page: 0, size: 999, searchKey: "" }),
        cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
        empty_delivery_challan.getEmptyDeliveryCylinderList(depot_id),
        empty_delivery_challan.getEmptyChallandepotList(depot_id),
        empty_delivery_challan.getEmptyChallanCustomerList(depot_id),
        supplierMasterService.getSupplierList({ page: 0, size: 999, searchKey: "" }),
      ]);

      setDepot(DdepotData);
      setDriver(driverData);
      setProduct(productData);
      setCustomer(DcustomerData);
      setVehicle(vehicleData);
      setCylinder(delivercylindrData);
      setDepot_name(depotData);
      setSupplier(supplierData);

      // ✅ Entry No Generation
      if (!editData) {
        const challanList = await empty_delivery_challan.getEmptyDeliverychallanList({ page: 0, size: 5, searchKey: "" });

        console.log("challanList:", challanList);
        console.log("All entry_nos:", challanList?.map(d => d.entry_no));

      const lastItem = challanList?.[0]; 
        const lastEntryNo = lastItem?.entry_no ?? "";
        console.log("lastEntryNo:", lastEntryNo);

        const parts = String(lastEntryNo).split("/");
        const lastSeq = parseInt(parts[parts.length - 1]) || 0;
        const nextSeq = lastSeq + 1;

        const yr = dayjs();
        const finYear = yr.month() >= 3
          ? `${String(yr.year()).slice(-2)}-${String(yr.year() + 1).slice(-2)}`
          : `${String(yr.year() - 1).slice(-2)}-${String(yr.year()).slice(-2)}`;

       const formattedEntryNo = `EC/${short_code}/${finYear}/${String(nextSeq).padStart(4, "0")}`;
        console.log("Generated entry_no:", formattedEntryNo);

        setData(prev => ({
          ...prev,
          entry_no: formattedEntryNo,
          fin_year: finYear,
        }));
      }

      if (editData) {
        // ... existing editData logic same rahega
      }

    } catch (error) { console.error("Data fetching failed", error); }
  }
  fetchData();
}, [editData, depot_id]);

  useEffect(() => {
    if (editData) {
      let to_location = editData.to_location || "";
      if (!to_location) {
        if (editData.to_depot_id) to_location = "depot";
        else if (editData.to_supplier_id) to_location = "supplier";
      }
      setDcType(to_location);
      setIsLocationSelected(!!to_location);
      setData({
        entry_no: editData.entry_no || "",
        entry_date: formatDateForAPI(editData.entry_date),
        from_depot: editData.from_depot || "",
        from_depot_id: editData.from_depot_id || "",
        to_customer: editData.customer_name || "",
        to_customer_id: editData.to_customer_id || "",
        to_depot: editData.depot_name || "",
        to_depot_id: editData.to_depot_id || "",
        to_supplier: editData.supplier_name || "",
        to_supplier_id: editData.to_supplier_id || "",
        to_location: to_location,
      
        table_details: editData.table_details || [],
        fin_year: editData.fin_year || "",
        unit_id: editData.unit_id || "",
        short_code: editData.short_code || "",
        vehicle_no: editData.vehicle_no || "",
driver_name: editData.driver_name || "",
      });
      if (editData.table_details) {
        let details = editData.table_details;
        if (typeof details === "string") { try { details = JSON.parse(details); } catch (e) { details = []; } }
        settable_details(details);
      }
    }
  }, [editData]);

  const handleTypeChange = (event, newValue) => {
    const value = newValue ? newValue.toLowerCase() : "";
    setDcType(value);
    setIsLocationSelected(!!value);
    setData((prevData) => ({
      ...prevData,
      to_location: value,
      type: value,
      to_customer: "",
      to_customer_id: "",
      to_depot: "",
      to_depot_id: "",
      to_supplier: "",
      to_supplier_id: "",
    }));
  };

  const handleChange = ({ target }) => {
    const { name, value } = target;
    let updatedFields = { [name]: value };
    if (name === "entry_date") {
      updatedFields.entry_date = formatDateForAPI(value);
      const selectedDate = dayjs(value);
      if (selectedDate.isValid()) {
        const month = selectedDate.month(), year = selectedDate.year();
        updatedFields.fin_year = month >= 3 ? `${year}-${year + 1}` : `${year - 1}-${year}`;
      }
    } else if (name === "from_depot_id") {
      const sel = depot.find(d => d.depot_id === value);
      if (sel) { updatedFields.from_depot = sel.depot_name; updatedFields.from_depot_id = sel.depot_id; }
    } else if (name === "to_depot_id") {
      const sel = depot.find(d => d.depot_id === value);
      if (sel) { updatedFields.to_depot = sel.depot_name; updatedFields.to_depot_id = sel.depot_id; }
    } else if (name === "to_customer_id") {
      const sel = customer.find(c => c.cust_id === value);
      if (sel) { updatedFields.to_customer = sel.cust_name; updatedFields.to_customer_id = sel.cust_id; }
} else if (name === "to_supplier_id") {
  const sel = supplier.find(s => s.supplier_id === value);
  if (sel) { updatedFields.to_supplier = sel.supplier_name; updatedFields.to_supplier_id = sel.supplier_id; }
} else if (name === "prod_code") {
 
  settable_details([]);
  setSelectedCylinders([]);
}
setData(prevData => ({ ...prevData, ...updatedFields }));
};
  const [isUpdateArray, setIsUpdateArray] = useState(false);
  const [table_details, settable_details] = useState(() => {
    if (editData) {
      try {
        const p = JSON.parse(editData.table_details);
        return p.map((row, index) => ({
          sr_no: index + 1,
          cyl_no: row.cyl_no || "",
          prod_code: row.prod_code || "",
          status: row.status || "Empty",
          tag_no: row.tag_no || "",
          owner: row.owner || "",
          remark: row.remark || "",
        }));
      } catch (e) { return [{ sr_no: 1, cyl_no: "", tag_no: "", owner: "", prod_code: "", status: "", remark: "" }]; }
    }
    return [{ sr_no: 1, cyl_no: "", tag_no: "", owner: "", prod_code: "", status: "", remark: "" }];
  });

 // onSubmit function ke shuru mein (already applied):
  const [isSubmitting, setIsSubmitting] = useState(false);
   const [showValidationError, setShowValidationError] = useState(false);

  const onSubmit = async () => {
    if (isSubmitting) return;
    if (
      !dcType ||
      (dcType === "depot" && !data.to_depot_id) ||
      (dcType === "supplier" && !data.to_supplier_id) ||
      !data.prod_code ||
      (!data.vehicle_no && !data.unregistered_vehicle) ||
      (!data.driver_name && !data.unregistered_driver) ||
      !table_details || table_details.length === 0 ||
      table_details.some(row => !row.cyl_no || !row.tag_no)
    ) {
      setShowValidationError(true);
     setSuccessMessage("Error Occurred! All fields are required");
      return;
    }
    setShowValidationError(false);
    setIsSubmitting(true);
    const dcData = {
      ...data,
      locationType: editData ? editData.locationType : dcType,
      entry_id: editData ? editData.entry_id : null,
      modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      modified_by: editData ? userInfo.user_id : null,
      created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      created_by: editData ? editData.created_by : userInfo.user_id,
      table_details: table_details || [],
      changedUpdatedValue: "edit",
      short_code,
      unit_id,
      to_location: dcType,
      update_check: checkboxValue,
     
      entry_date: formatDateForAPI(data.entry_date),
    };
    try {
      if (editData) await empty_delivery_challan.editDeleteEmptyDeliverychallan(dcData);
      else await empty_delivery_challan.addEmptyDeliverychallan(dcData);
      setSuccessMessage(editData ? "Updated successfully" : "Added successfully");
      setTimeout(() => navigate(-1), 1000);
      } catch (error) { console.error("Submit error:", error); setSuccessMessage("Error occurred during submission"); setIsSubmitting(false); }
  };

  const [successMessage, setSuccessMessage] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCylinders, setSelectedCylinders] = useState([]);

  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);

  const handleCylinderSelect = (cyl) => {
    const alreadySelected = selectedCylinders.find(c => c.cylinder_no === cyl.cylinder_no);
    let updatedCylinders;
    if (alreadySelected)
      updatedCylinders = selectedCylinders.filter(c => c.cylinder_no !== cyl.cylinder_no);
    else
      updatedCylinders = [
        ...selectedCylinders,
        {
          cyl_id: cyl.cyl_id,
          cylinder_no: cyl.cylinder_no,
          prod_code: cyl.prod_code,
          status: cyl.status,
          tag_no: cyl.tag_no || "",
          owner: cyl.owner || "",
         remark: cyl.remark || cyl.level || cyl.note || "",
        },
      ];
    setSelectedCylinders(updatedCylinders);
  };

  const handleDialogConfirm = () => {
    settable_details(
      selectedCylinders.map((cyl, index) => ({
        sr_no: index + 1,
        cyl_id: cyl.cyl_id,
        cyl_no: cyl.cylinder_no,
        prod_code: cyl.prod_code,
        status: cyl.status,
        tag_no: cyl.tag_no || "",
        owner: cyl.owner || "",
        remark: cyl.remark,
      }))
    );
    setIsUpdateArray(prev => !prev);
    handleCloseDialog();
  };

  const handleRemoveCylinder = (index) => {
    settable_details(table_details.filter((_, i) => i !== index));
    setIsUpdateArray(prev => !prev);
  };

  const handleCheckboxChange = (event) => setCheckboxValue(event.target.checked ? 1 : 0);

  const acInput = (params, placeholder = "") => (
    <TextField {...params} size="small" fullWidth placeholder={placeholder} sx={inputSx} />
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={pageSx}>
        {/* Breadcrumb */}
        <Box sx={breadcrumbSx}>
          <span>Dashboard</span> / <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Empty Challan</span>
        </Box>

        {/* Page Header */}
        <Box sx={pageHeaderSx}>
          <Box sx={pageTitleSx}>
            <LocalShippingIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
            {editData ? "UPDATE" : "ADD"} EMPTY CHALLAN
          </Box>
          <Button onClick={() => navigate(-1)} sx={backBtnSx}>
            <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
          </Button>
        </Box>

        <form onSubmit={handleSubmit(onSubmit)}>
          {/* ── Empty Challan Details Card ───────────────────────────── */}
          <Box sx={formCardSx}>
            <Box sx={sectionHeaderSx}>
              <LocalShippingIcon sx={{ fontSize: 18, color: "#fff" }} />
              <Typography sx={sectionHeaderTitleSx}>EMPTY CHALLAN DETAILS</Typography>
            </Box>

            <Box sx={formBodySx}>
              {/* Two-column container matching Cylinder Inward layout */}
              <Grid container sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

                {/* ════ LEFT COLUMN — Destination & Location ════ */}
                <Grid
                  item xs={12} md={6}
                  sx={{
                    p: 2.5,
                    borderBottom: { xs: "2px dashed #CBD5E0", md: "none" },
                  }}
                >
                  <Grid container spacing={1.5}>

                    {/* Product Code */}
                  

                    {/* To Location */}
                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>
                        To Location <span style={{ color: "#E53E3E" }}>*</span>
                      </Typography>
                    <Autocomplete
  disablePortal
  options={["Depot", "Supplier"]}
  value={dcType ? dcType.charAt(0).toUpperCase() + dcType.slice(1) : ""}
  onChange={handleTypeChange}
  renderInput={(params) => (
    <TextField
      {...params}
      size="small"
      fullWidth
      placeholder="Select location"
      sx={inputSx}
      inputProps={{
        ...params.inputProps,
        readOnly: true,
      }}
    />
  )}
/>
                    </Grid>

                    {/* Depot selector */}
                  {isLocationSelected && dcType === "depot" && (
  <Grid item xs={7} sm={5}>
    <Typography sx={fieldLabelSx}>
      Depot <span style={{ color: "#E53E3E" }}>*</span>
    </Typography>
    <Autocomplete
      disablePortal
      options={depot}
      getOptionLabel={o => typeof o === "string" ? o : o.depot_name || ""}
      value={depot.find(i => i.depot_id === data.to_depot_id) || null}
      onChange={(e, nv) => handleChange({ target: { name: "to_depot_id", value: nv ? nv.depot_id : "" } })}
      disabled={!!editData}
      renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.depot_name}</MenuItem>}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          fullWidth
          placeholder="Select depot"
          sx={inputSx}
          inputProps={{
            ...params.inputProps,
            readOnly: true,
          }}
        />
      )}
    />
  </Grid>
)}
<Grid item xs={7} sm={5}>
  <Typography sx={fieldLabelSx}>Product Code <span style={{ color: "#E53E3E" }}>*</span></Typography>
  <Autocomplete
    disablePortal fullWidth options={product}
    componentsProps={{
      popper: {
        placement: "bottom-start",
        modifiers: [{ name: "flip", enabled: false }],
      },
    }}
    getOptionLabel={o => o.prod_code || ''}
    value={product.find(o => o.prod_code === (data.prod_code || "")) || null}
    onChange={(e, nv) => handleChange({ target: { name: 'prod_code', value: nv ? nv.prod_code : '' } })}
    isOptionEqualToValue={(o, v) => o.prod_code === v.prod_code}
    renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.prod_code}</MenuItem>}
    renderInput={(params) => (
      <TextField
        {...params}
        size="small"
        fullWidth
        placeholder="Select product"
        sx={inputSx}
        error={!data.prod_code && showValidationError}
        helperText={!data.prod_code && showValidationError ? "Product Code is required" : ""}
        FormHelperTextProps={{ sx: { fontSize: "11px", color: "#E53E3E" } }}
      />
    )}
  />
</Grid>
                    {/* Supplier selector */}
                    {isLocationSelected && dcType === "supplier" && (
                      <Grid item xs={7} sm={5}>
                        <Typography sx={fieldLabelSx}>
                          Supplier <span style={{ color: "#E53E3E" }}>*</span>
                        </Typography>
                        <Autocomplete
                          disablePortal
                          options={supplier}
                          getOptionLabel={o => typeof o === "string" ? o : o.supplier_name || ""}
                          value={supplier.find(i => i.supplier_id === data.to_supplier_id) || null}
                          onChange={(e, nv) => handleChange({ target: { name: "to_supplier_id", value: nv ? nv.supplier_id : "" } })}
                          renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.supplier_name}</MenuItem>}
                          renderInput={(params) => acInput(params, "Select supplier")}
                        />
                      </Grid>
                    )}

                    {/* Driver Name */}
                 

                  </Grid>
                </Grid>

                {/* ════ RIGHT COLUMN — Entry & Vehicle Info ════ */}
                <Grid
                  item xs={12} md={6}
                  sx={{ p: 2.5, background: "#FAFBFC", pl: 3.5 }}
                >
                  <Grid container spacing={1.5}>

                    {/* Entry No */}
                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Entry No</Typography>
                      <TextField
                        size="small" fullWidth name="entry_no"
                        value={data.entry_no}
                        sx={readonlyInputSx}
                        InputProps={{ readOnly: true }}
                        placeholder="Auto-generated"
                      />
                    </Grid>

                    {/* Entry Date */}
                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>
                        Entry Date <span style={{ color: "#E53E3E" }}>*</span>
                      </Typography>
                      <DatePicker
                        format="DD/MM/YYYY"
                        value={dayjs(data.entry_date)}
                        onChange={nv => handleChange({ target: { name: "entry_date", value: nv ? nv.toDate() : "" } })}
                        slotProps={{ textField: { size: "small", fullWidth: true, required: true, sx: inputSx } }}
                      />
                    </Grid>

                       <Grid item xs={7} sm={6}>
                      <Typography sx={fieldLabelSx}>
                        Driver Name <span style={{ color: "#E53E3E" }}>*</span>
                      </Typography>
                      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                       <Autocomplete
  freeSolo disablePortal fullWidth options={driver || []} clearIcon={false}
  getOptionLabel={o => typeof o === "string" ? o : o.driver_name || ""}
  value={driver.find(d => d.driver_name === data.driver_name) || data.driver_name || null}
  onChange={(e, nv) => {
    if (nv && typeof nv === "object") {
      handleChange({ target: { name: "driver_name", value: nv.driver_name } });
    } else if (typeof nv === "string") {
      handleChange({ target: { name: "driver_name", value: nv } });
    } else {
      handleChange({ target: { name: "driver_name", value: "" } });
    }
  }}
  onInputChange={(e, inputValue, reason) => {
    if (reason === "input") {
      handleChange({ target: { name: "driver_name", value: inputValue } });
    }
  }}
  renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.driver_name}</MenuItem>}
  renderInput={(params) => acInput(params, "Select or type driver name")}
/>
                        {/* <IconButton
                          onClick={toggleUnregisteredDriver}
                          sx={{
                            width: "36px", height: "36px",
                            background: showUnregisteredDriver ? "#EBF4FF" : "#F0F4F8",
                            border: "1.5px solid #E2E8F0", borderRadius: "8px",
                            "&:hover": { background: "#EBF4FF" },
                          }}
                        >
                          <AddIcon sx={{ fontSize: "18px", color: "#2063b6" }} />
                        </IconButton> */}
                      </Box>
                      {/* {showUnregisteredDriver && (
                        <Box sx={{ mt: 1.5 }}>
                          <Typography sx={{ ...fieldLabelSx, color: "#718096" }}>Unlisted Driver Name</Typography>
                          <TextField
                            size="small" fullWidth name="unregistered_driver"
                            value={data.unregistered_driver || ""}
                            onChange={handleChange} sx={inputSx}
                            placeholder="Enter unlisted driver name"
                          />
                        </Box>
                      )} */}
                    </Grid>

                    {/* Vehicle No */}
                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>
                        Vehicle No <span style={{ color: "#E53E3E" }}>*</span>
                      </Typography>
                      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
<Autocomplete
  freeSolo disablePortal fullWidth options={vehicle || []} clearIcon={false}
  getOptionLabel={o => typeof o === "string" ? o : o.vehicle_no || ""}
  value={vehicle.find(v => v.vehicle_no === data.vehicle_no) || data.vehicle_no || null}
  onChange={(e, nv) => {
    if (nv && typeof nv === "object") {
      handleChange({ target: { name: "vehicle_no", value: nv.vehicle_no } });
    } else if (typeof nv === "string") {
      handleChange({ target: { name: "vehicle_no", value: nv } });
    } else {
      handleChange({ target: { name: "vehicle_no", value: "" } });
    }
  }}
  onInputChange={(e, inputValue, reason) => {
    if (reason === "input") {
      handleChange({ target: { name: "vehicle_no", value: inputValue } });
    }
  }}
  renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.vehicle_no}</MenuItem>}
  renderInput={(params) => acInput(params, "Select or type vehicle no")}
/>
                        {/* <IconButton
                          onClick={toggleUnregisteredVehicle}
                          sx={{
                            width: "36px", height: "36px",
                            background: showUnregisteredVehicle ? "#EBF4FF" : "#F0F4F8",
                            border: "1.5px solid #E2E8F0", borderRadius: "8px",
                            "&:hover": { background: "#EBF4FF" },
                          }}
                        >
                          <AddIcon sx={{ fontSize: "18px", color: "#2063b6" }} />
                        </IconButton> */}
                      </Box>
                      {/* {showUnregisteredVehicle && (
                        <Box sx={{ mt: 1.5 }}>
                          <Typography sx={{ ...fieldLabelSx, color: "#718096" }}>Unlisted Vehicle No</Typography>
                          <TextField
                            size="small" fullWidth name="unregistered_vehicle"
                            value={data.unregistered_vehicle || ""}
                            onChange={handleChange} sx={inputSx}
                            placeholder="Enter unlisted vehicle number"
                          />
                        </Box>
                      )} */}
                    </Grid>

                  </Grid>
                </Grid>

              </Grid>
            </Box>
          </Box>

          {/* Select Cylinders button */}
          <Box sx={{ px: 3, pt: 1, pb: 1 }}>
            <Button
              variant="contained"
              onClick={handleOpenDialog}
              startIcon={<AddIcon />}
              sx={{
                background: "#2B6CB0", color: "#fff", fontWeight: 600,
                fontSize: "13px", px: 3, py: 1, borderRadius: "8px",
                textTransform: "none", "&:hover": { background: "#04407d" },
              }}
            >
              Select Cylinders
            </Button>
          </Box>

          {/* ── Cylinder List ──────────────────────────────────────────── */}
          <Box sx={formCardSx}>
            <TableContainer>
              <Table size="small" stickyHeader>
                <TableHead>
                  <tr>
                   {["Sr No", "Cylinder No", "Tag No", "Owner", "Status", "Remark", "Action"].map(h => (
  <th key={h} style={{
    background: "#1C3A5E", color: "#fff", fontSize: "12px",
    fontWeight: 600, fontFamily: "'Inter', Arial, sans-serif",
    padding: "10px 12px", borderRight: "1px solid rgba(255,255,255,0.1)",
    whiteSpace: "nowrap",
    textAlign: ["Sr No", "Action"].includes(h) ? "center" : "left",
  }}>{h}</th>
))}
                  </tr>
                </TableHead>
                <TableBody>
                  {table_details && table_details.length > 0 && table_details[0].cyl_no !== "" ? (
                    table_details.map((row, index) => (
                      <tr
                        key={index}
                        style={{
                          background: index % 2 === 0 ? "#fff" : "#F8FAFC",
                          borderBottom: "1px solid #E2E8F0",
                        }}
                      >
                        {/* Sr No — non-editable */}
                        <td style={{padding: "8px 12px", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "center" }}>
                          {index + 1}
                        </td>
                        {/* Cylinder No — non-editable */}
                        <td style={{ padding: "8px 12px", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "left" }}>
                          {row.cyl_no}
                        </td>
                        {/* Tag No — non-editable */}
                        <td style={{padding: "8px 12px", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "left"  }}>
                          {row.tag_no || "—"}
                        </td>
                        {/* Owner — non-editable */}
                        <td style={{ padding: "8px 12px", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748", textAlign: "left" }}>
                          {row.owner || "—"}
                        </td>
                        {/* Status — non-editable */}
                        <td style={{ padding: "8px 12px", textAlign: "left" }}>
                          <Box sx={{
                            display: "inline-flex", alignItems: "center",
                            px: 1.5, py: 0.3, borderRadius: "20px",
                            fontSize: "11px", fontWeight: 600,
                            background: row.status === "Full" ? "#FFF5F5" : "#F0FFF4",
                            color: row.status === "Full" ? "#E53E3E" : "#38A169",
                          }}>
                            {row.status || "Empty"}
                          </Box>
                        </td>
                        {/* Remark — non-editable */}
                        <td style={{ padding: "8px 12px", fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", color: "#718096", textAlign: "left"  }}>
                          {row.remark || "—"}
                        </td>
                        {/* Action */}
                        <td style={{ padding: "8px 12px", textAlign: "center" }}>
                          <IconButton
                            size="small"
                            onClick={() => handleRemoveCylinder(index)}
                            sx={{ color: "#E53E3E", "&:hover": { background: "#FFF5F5" }, borderRadius: "6px" }}
                          >
                            <DeleteForeverIcon sx={{ fontSize: "18px" }} />
                          </IconButton>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={7}
                        style={{
                          padding: "32px", textAlign: "center",
                          color: "#A0AEC0", fontSize: "13px",
                          fontFamily: "'Inter', Arial, sans-serif",
                        }}
                      >
                        No cylinders selected. Click "Select Cylinders" to add.
                      </td>
                    </tr>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Confirm Status Update checkbox (edit mode only) */}
            {editData && (
              <Box sx={{ px: 3, pt: 2 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkboxValue === 1}
                      onChange={handleCheckboxChange}
                      size="small"
                      sx={{ color: "#2063b6", "&.Mui-checked": { color: "#2063b6" } }}
                    />
                  }
                  label={
                    <Typography sx={{ fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", color: "#2D3748" }}>
                      Confirm Status Update
                    </Typography>
                  }
                />
              </Box>
            )}

            {/* Footer Buttons */}
            <Box sx={formFooterSx}>
              <Button sx={cancelBtnSx} onClick={() => navigate(-1)}>Cancel</Button>
              <Button type="submit" sx={saveBtnSx} disabled={isSubmitting}>
                <SaveIcon sx={{ fontSize: 18 }} />
                {isSubmitting ? "Saving..." : editData ? "Update" : "Save"}
              </Button>
            </Box>
          </Box>
        </form>

        {/* ── Select Cylinders Dialog ─────────────────────────────────── */}
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth="md"
          fullWidth
          PaperProps={{ sx: { borderRadius: "14px", border: "1px solid #E2E8F0" } }}
        >
          {/* Dialog Header */}
          <Box sx={{
            background: "#1C3A5E", padding: "14px 22px",
            display: "flex", alignItems: "center", justifyContent: "space-between",
          }}>
            <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#fff", fontFamily: "'Inter', Arial, sans-serif" }}>
              Select Cylinders
              <Box
                component="span"
                sx={{
                  ml: 1.5, px: 1.5, py: 0.3,
                  background: "rgba(255,255,255,0.15)",
                  borderRadius: "20px", fontSize: "12px",
                }}
              >
               {selectedCylinders.length} selected / {cylinder.filter(cyl => !data.prod_code || cyl.prod_code === data.prod_code).length} available
              </Box>
            </Typography>
          </Box>

          <DialogContent sx={{ pt: 3 }}>
            <Grid container spacing={1.5}>
             {cylinder.filter(cyl => !data.prod_code || cyl.prod_code === data.prod_code).map((cyl) => {
                const isSelected = selectedCylinders.some(c => c.cylinder_no === cyl.cylinder_no);
                return (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={cyl.cylinder_no}>
                    <Box
                      onClick={() => handleCylinderSelect(cyl)}
                      sx={{
                        background: isSelected ? "#2B6CB0" : "#F7FAFC",
                        color: isSelected ? "#fff" : "#2D3748",
                        cursor: "pointer",
                        /* No border radius — flat rectangle */
                        borderRadius: 0,
                        padding: "12px 14px",
                        transition: "all 0.15s ease",
                        border: isSelected ? "2px solid #2B6CB0" : "2px solid #E2E8F0",
                        "&:hover": {
                          background: isSelected ? "#2563A8" : "#EBF4FF",
                          borderColor: "#2B6CB0",
                        },
                      }}
                    >
                      {/* Field order: Cylinder Number → Tag Number → Owner */}
                      <Typography sx={{ fontWeight: 700, fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif", mb: 0.5 }}>
                        {cyl.cylinder_no}
                      </Typography>
                      <Typography sx={{ fontSize: "11px", opacity: isSelected ? 0.9 : 0.7, fontFamily: "'Inter', Arial, sans-serif" }}>
                        Tag: {cyl.tag_no || "—"}
                      </Typography>
                      <Typography sx={{ fontSize: "11px", opacity: isSelected ? 0.9 : 0.7, fontFamily: "'Inter', Arial, sans-serif" }}>
                        Owner: {cyl.owner || "—"}
                      </Typography>
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
            <Button onClick={handleCloseDialog} sx={cancelBtnSx}>Cancel</Button>
            <Button onClick={handleDialogConfirm} sx={saveBtnSx}>
              Confirm Selection
            </Button>
          </DialogActions>
        </Dialog>

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(e, reason) => { if (reason !== "clickaway") setSuccessMessage(""); }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </LocalizationProvider>
  );
};

export default AddEmptyDeliveryChllan;